document.addEventListener('DOMContentLoaded', function() {
  document.documentElement.style.setProperty('--scrollbar-w', getScrollBarWidth.init() + 'px');
});
var root = document.body;
function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
function getCookie(e) {
  let t = e + "=",
    i = decodeURIComponent(document.cookie).split(";");
  for (let s = 0; s < i.length; s++) {
    let r = i[s];
    for (; " " == r.charAt(0); ) r = r.substring(1);
    if (0 == r.indexOf(t)) return r.substring(t.length, r.length);
  }
  return "";
}
function deleteCookie(e) {
  document.cookie = e + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
function setCookie(e, t, i) {
  let s = new Date();
  s.setTime(s.getTime() + 864e5 * i);
  let r = "expires=" + s.toUTCString();
  document.cookie = e + "=" + t + ";" + r + ";path=/";
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
function HoverIntent(e, t) {
  let i = { exitDelay: 180, interval: 100, sensitivity: 6 },
    s = {},
    r,
    a,
    o,
    n,
    l,
    c,
    d,
    u = function (e, t) {
      for (let i in t) e[i] = t[i];
      return e;
    },
    h = function (e) {
      (r = e.pageX), (a = e.pageY);
    },
    p = function (e) {
      let t = o - r,
        i = n - a;
      if (Math.sqrt(t * t + i * i) < s.sensitivity) {
        for (let u of (clearTimeout(d), l))
          u.isActive && (s.onExit(u), (u.isActive = !1));
        s.onEnter(e), (e.isActive = !0);
      } else
        (o = r),
          (n = a),
          (c = setTimeout(function () {
            p(e);
          }, s.interval));
    };
  !(function (e, t) {
    if (!t || !t.onEnter || !t.onExit)
      throw "onEnter and onExit callbacks must be provided";
    for (let r of ((s = u(i, t)), (l = e))) {
      if (!r) return;
      (r.isActive = !1),
        r.addEventListener("mousemove", h),
        r.addEventListener("mouseenter", function (e) {
          if (((o = e.pageX), (n = e.pageY), r.isActive)) {
            clearTimeout(d);
            return;
          }
          c = setTimeout(function () {
            p(r);
          }, s.interval);
        }),
        r.addEventListener("mouseleave", function (e) {
          clearTimeout(c),
            r.isActive &&
              (d = setTimeout(function () {
                s.onExit(r), (r.isActive = !1);
              }, s.exitDelay));
        });
    }
  })(e, t);
}
function initLazyloadItem() {
  let e = document.querySelectorAll("video.lazy-video-item, video.lazy-video"),
    t = new IntersectionObserver(
      (e, t) => {
        e.forEach((e) => {
          if (e.isIntersecting) {
            let i = e.target,
              s = i.dataset.poster,
              r = i.dataset.src;
            s &&
              (i.setAttribute("poster", s),
              i.removeAttribute("data-poster"),
              i.setAttribute("src", r),
              i.removeAttribute("data-src")),
              i.querySelectorAll("source").forEach((e) => {
                let t = e.dataset.src;
                t && (e.setAttribute("src", t), e.removeAttribute("data-src"));
              }),
              i.classList.remove("lazy-video-item", "lazy-video"),
              t.unobserve(i);
          }
        });
      },
      { threshold: 0.1, rootMargin: "200px 0px" }
    );
  e.forEach((e) => t.observe(e));
}
function eventFlashingBrowseTab() {
  var e,
    t,
    i = window.flashingBrowseTab?.enable,
    s = document.getElementsByTagName("title")[0],
    r = window.flashingBrowseTab?.firstNotification,
    a = window.flashingBrowseTab?.secondaryNotification;
  if (i && s) {
    var o = s.innerText,
      n = !0;
    document.addEventListener("visibilitychange", () => {
      var i;
      "visible" === document.visibilityState
        ? n || (clearInterval(e), (s.innerText = o))
        : ((i = 1),
          (n = !1),
          !r ||
            !a ||
            (e = setInterval(function () {
              1 == i ? ((t = r), (i = 2)) : ((t = a), (i = 1)),
                (s.innerText = t);
            }, 2e3)));
    });
  }
}
function initializeLazyLoad() {
  let e = document.querySelectorAll(".lazy-video-link"),
    t = (e) => {
      let t = e.getAttribute("data-video-id"),
        i = document.createElement("iframe");
      (i.src = `https://www.youtube.com/embed/${t}?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=${t}`),
        (i.allowFullscreen = !0),
        (i.frameBorder = "0"),
        (i.allow =
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"),
        (e.innerHTML = ""),
        e.appendChild(i);
    },
    i = (e) => {
      let t = e.getAttribute("data-video-id"),
        i = document.createElement("iframe");
      (i.src = `https://player.vimeo.com/video/${t}?controls=0background=1&autoplay=1&muted=1&loop=1`),
        (i.allowFullscreen = !0),
        (i.allow = "autoplay; fullscreen; picture-in-picture"),
        (i.frameBorder = "0"),
        (e.innerHTML = ""),
        e.appendChild(i);
    },
    s = (e) => {
      let s = e.getAttribute("data-video-type");
      "youtube" === s ? t(e) : "vimeo" === s && i(e);
    };
  (() => {
    let t = new IntersectionObserver((e, t) => {
      e.forEach((e) => {
        e.isIntersecting && (s(e.target), t.unobserve(e.target));
      });
    });
    e.forEach((e) => {
      t.observe(e);
    });
  })();
}
(Shopify.bind = function (e, t) {
  return function () {
    return e.apply(t, arguments);
  };
}),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var r = e.options[i];
      if (t == r.value || t == r.innerHTML) return (e.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e?.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i = (t = t || {}).method || "post",
      s = t.parameters || {},
      r = document.createElement("form");
    for (var a in (r.setAttribute("method", i),
    r.setAttribute("action", e),
    s)) {
      var o = document.createElement("input");
      o.setAttribute("type", "hidden"),
        o.setAttribute("name", a),
        o.setAttribute("value", s[a]),
        r.appendChild(o);
    }
    document.body.appendChild(r), r.submit(), document.body.removeChild(r);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = this.countryEl.options[this.countryEl.selectedIndex],
        i = JSON.parse(t.getAttribute("data-provinces"));
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s = 0; s < i.length; s++) {
          var t = document.createElement("option");
          (t.value = i[s][0]),
            (t.innerHTML = i[s][1]),
            this.provinceEl.appendChild(t);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      for (var i = 0; i < t.length; i++) {
        var s = document.createElement("option");
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
      t.length;
    },
  }),
  (Shopify.formatMoney = function (e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    var i = "",
      s = /\{\{\s*(\w+)\s*\}\}/,
      r = t || this.money_format;
    function a(e, t) {
      return void 0 === e ? t : e;
    }
    function o(e, t, i, s) {
      if (
        ((t = a(t, 2)), (i = a(i, ",")), (s = a(s, ".")), isNaN(e) || null == e)
      )
        return 0;
      var r,
        o = (e = (e / 100).toFixed(t)).split(".");
      return (
        o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
        (o[1] ? s + o[1] : "")
      );
    }
    switch (r.match(s)[1]) {
      case "amount":
        i = o(e, 2);
        break;
      case "amount_no_decimals":
        i = o(e, 0);
        break;
      case "amount_with_comma_separator":
        i = o(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = o(e, 0, ".", ",");
    }
    return r.replace(s, i);
  }),
  initLazyloadItem(),
  eventFlashingBrowseTab(),
  initializeLazyLoad();
const slideAnime = (() => {
  let e = !1;
  return (t) => {
    let i = {
        target: !1,
        animeType: "slideToggle",
        duration: 250,
        easing: "ease",
        isDisplayStyle: "block",
        parent: !1,
        addFunction() {},
      },
      s = Object.assign({}, i, t),
      r = s.target,
      a = s.ownAnimate;
    a && (e = !1);
    let o = s.parent;
    if (!r || e) return;
    (e = !0), o.classList?.toggle("opened");
    let n = s.animeType,
      l = getComputedStyle(r);
    if (
      ("slideToggle" === n &&
        (n = "none" === l.display ? "slideDown" : "slideUp"),
      ("slideUp" === n && "none" === l.display) ||
        ("slideDown" === n && "none" !== l.display) ||
        ("slideUp" !== n && "slideDown" !== n))
    )
      return (e = !1), !1;
    r.style.overflow = "hidden";
    let c = s.duration,
      d = s.easing,
      u = s.isDisplayStyle;
    "slideDown" === n && (r.style.display = u);
    let h = {
      height: r.getBoundingClientRect().height + "px",
      marginTop: l.marginTop,
      marginBottom: l.marginBottom,
      paddingTop: l.paddingTop,
      paddingBottom: l.paddingBottom,
    };
    if (
      (Object.keys(h).forEach((e) => {
        0 === parseFloat(h[e]) && delete h[e];
      }),
      0 === Object.keys(h).length)
    )
      return (e = !1), !1;
    let p;
    "slideDown" === n
      ? (Object.keys(h).forEach((e) => {
          r.style[e] = 0;
        }),
        (p = r.animate(h, { duration: c, easing: d })))
      : "slideUp" === n &&
        (Object.keys(h).forEach((e) => {
          (r.style[e] = h[e]), (h[e] = 0);
        }),
        (p = r.animate(h, { duration: c, easing: d }))),
      p.finished.then(() => {
        s.addFunction(),
          (r.style.overflow = ""),
          Object.keys(h).forEach((e) => {
            r.style[e] = "";
          }),
          "slideUp" === n && (r.style.display = "none"),
          (e = !1);
      });
  };
})();
class MultiContent extends SlideSection {
  constructor() {
    super(),
      (this.enable = this.dataset.enable),
      (this.swiperSlideInnerHtml = this.innerHTML),
      this.init();
  }
  init() {
    if ("true" == this.enable) {
      let e = window.innerWidth;
      window.addEventListener("resize", () => {
        let t = window.innerWidth;
        t <= 767 && e > 767 && this.actionOnMobile(),
          t > 767 && e <= 767 && this.actionOutMobile(),
          (e = t);
      }),
        e <= 576 ? this.actionOnMobile() : this.actionOutMobile();
    }
  }
  actionOnMobile() {
    this.classList.add("swiper");
    let e = this.swiperSlideInnerHtml.replaceAll(
        "section__block",
        "swiper-slide"
      ),
      t = `<div class='swiper-wrapper'>${e}</div> <div
    class="swiper-pagination  ${
      this.enable && 1.5 != this.dataset.mobile ? "flex" : "hidden"
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    (this.innerHTML = t), this.initSlide();
  }
  actionOutMobile() {
    this.classList.contains("swiper") &&
      (this.classList.remove("swiper"),
      (this.innerHTML = this.swiperSlideInnerHtml));
  }
}
customElements.define("multi-content", MultiContent);
var getScrollBarWidth = {
  cachedWidth: null,
  init: function () {
    if (this.cachedWidth !== null) return this.cachedWidth;
    var e = document.createElement("div");
    (e.style.width = "100px"),
      (e.style.height = "100px"),
      (e.style.overflow = "scroll"),
      (e.style.position = "absolute"),
      (e.style.top = "-9999px"),
      document.body.appendChild(e);
    var t = e.offsetWidth - e.clientWidth;
    document.body.removeChild(e);
    this.cachedWidth = t;
    return t;
  },
};
  wishlistHeader = {
    init: function () {
      this.handleCount();
    },
    handleCount: function () {
      let e = document.querySelectorAll(".wishlist-count"),
        t = JSON.parse(localStorage.getItem("glozin__wishlist-items"));
      e.forEach((e) => {
        e.innerText = null !== t && 0 != t.length ? t.length : 0;
      });
    },
  };
wishlistHeader.init();
var BlsSearchShopify = {
  init: function () {
    document.querySelector("#predictive-search") && this.setupEventListeners();
    let e = document.querySelector("#search-form");
    document.querySelectorAll(".top-search-toggle").forEach((t) => {
      t.addEventListener("click", (t) => {
        let i = t.currentTarget;
        e.classList.contains("open")
          ? (e.classList.remove("open"),
            i.classList.remove("open"),
            document.documentElement.classList.remove(
              "open-drawer",
              "open-search",
              "no-scroll"
            ))
            : (e.classList.add("open"),
            i.classList.add("open"),
            document.documentElement.classList.add(
              "open-drawer",
              "open-search",
              "no-scroll"
            ),
            setTimeout(function () {
              e.querySelector('input[type="search"]').focus();
            }, 100));
      });
    }),
      document.querySelectorAll(".btn-search-close").forEach((t) => {
        t.addEventListener("click", () => {
          e.classList.remove("open"),
            document
              .querySelector(".dropdown-toggle .top-search-toggle")
              .classList.remove("open"),
            document.documentElement.classList.remove(
              "open-drawer",
              "open-search",
              "no-scroll"
            );
        });
      });
    let t = document.querySelector(".search-full");
    if (t) {
      let i = t.closest(".header_search");
      document.addEventListener("click", (e) => {
        let t = e.target.closest(".header_search");
        if (t) {
          let s = t.querySelector(".popup-search");
          s &&
            (s.classList.add("popup-search-show"),
            e.target && e.target.classList.contains("popup-search-show")
              ? (s.classList.remove("popup-search-show"),
                document.documentElement.classList.remove(
                  "open-drawer",
                  "open-search"
                ),
                root.style.removeProperty("padding-right"))
              : (document.documentElement.classList.add(
                  "open-drawer",
                  "open-search"
                ),
                root.style.setProperty(
                  "padding-right",
                  getScrollBarWidth.init() + "px"
                )));
        } else if (i) {
          let r = i.querySelector(".popup-search");
          r &&
            (r.classList.remove("popup-search-show"),
            document.documentElement.classList.contains("open-search") &&
              (document.documentElement.classList.remove(
                "open-drawer",
                "open-search"
              ),
              root.style.removeProperty("padding-right")));
        }
      });
    }
  },
  setupEventListeners: function () {
    let e = document.querySelector('input[type="search"]'),
      t = document.querySelector("form.search");
    t.addEventListener("submit", this.onFormSubmit.bind(this)),
      e.addEventListener(
        "input",
        this.debounce((e) => {
          this.onChange(e);
        }, 300).bind(this)
      ),
      e.addEventListener("focus", this.onFocus.bind(this)),
      document.addEventListener("focusout", this.onFocusOut.bind(this)),
      document.addEventListener("keyup", this.onKeyup.bind(this));
  },
  debounce: function (e, t) {
    let i;
    return (...s) => {
      clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
    };
  },
  getQuery: function () {
    return document.querySelector('input[type="search"]').value.trim();
  },
  onChange: function () {
    let e = this.getQuery();
    if (!e.length) {
      this.close(!0);
      return;
    }
    this.getSearchResults(e);
  },
  onFormSubmit: function (e) {
    (!this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')) &&
      e.preventDefault();
  },
  onFocus: function () {
    let e = this.getQuery();
    e.length &&
      (document
        .querySelector("#predictive-search")
        .classList.contains("results")
        ? this.open()
        : this.getSearchResults(e));
  },
  onFocusOut: function () {
    setTimeout(() => {
      document.contains(document.activeElement) || this.close();
    });
  },
  onKeyup: function (e) {
    switch (
      (this.getQuery().length || this.close(!0), e.preventDefault(), e.code)
    ) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
    }
  },
  switchOption: function (e) {
    if (!this.getAttribute("open")) return;
    let t = "up" === e,
      i = document.querySelector('[aria-selected="true"]'),
      s = document.querySelectorAll("li"),
      r = document.querySelector("li");
    (!t || i) &&
      ((this.statusElement.textContent = ""),
      !t && i
        ? (r = i.nextElementSibling || s[0])
        : t && (r = i.previousElementSibling || s[s.length - 1]),
      r !== i &&
        (r.setAttribute("aria-selected", !0),
        i && i.setAttribute("aria-selected", !1),
        document
          .querySelector('input[type="search"]')
          .setAttribute("aria-activedescendant", r.id)));
  },
  selectOption: function () {
    let e = document.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );
    e && e.click();
  },
  getSearchResults: function (e) {
    let t = {},
      i = e.replace(" ", "-").toLowerCase();
    if ((this.setLiveRegionLoadingState(), t[i])) {
      this.renderSearchResults(t[i]);
      return;
    }
    var s = "search-predictive-grid";
    if (document.querySelector(".predictive_search_suggest"))
      var r = `${routes?.predictive_search_url}?q=${encodeURIComponent(
        e
      )}&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=query,product,collection,page,article&section_id=${s}`;
    else
      var r = `${routes.search_url}?q=${encodeURIComponent(
        e
      )}&options[prefix]=last&options[unavailable_products]=last&type=query,product,collection,page,article&section_id=${s}`;
    fetch(`${r}`)
      .then((e) => {
        if (!e.ok) {
          var t = Error(e.status);
          throw (this.close(), t);
        }
        return e.text();
      })
      .then((e) => {
        let r = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("#shopify-section-" + s).innerHTML;
        (t[i] = r), this.renderSearchResults(r);
      })
      .catch((e) => {
        throw (this.close(), e);
      });
  },
  setLiveRegionLoadingState: function () {
    document.querySelector("#search_mini_form").classList.add("loading"),
      document.querySelector("#predictive-search").classList.add("loading");
  },
  setLiveRegionResults: function () {
    document.querySelector("#search_mini_form").classList.remove("loading"),
      document.querySelector("#predictive-search").classList.remove("loading");
  },
  renderSearchResults: function (e) {
    (document.querySelector("[data-predictive-search]").innerHTML = e),
      document.querySelector("#predictive-search").classList.add("results"),
      document.querySelector(".search-not-sugges") &&
        (document
          .querySelector(".search-not-sugges")
          .classList.remove("search-hidden"),
        document.documentElement.classList.add("open-drawer", "open-search"),
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        ));
    let t = document.querySelector("#quick-search");
    t && t.classList.add("hidden"), this.setLiveRegionResults(), this.open();
  },
  open: function () {
    document
      .querySelector('input[type="search"]')
      .setAttribute("aria-expanded", !0),
      (this.isOpen = !0);
  },
  close: function (e = !1) {
    if (e) {
      (document.querySelector('input[type="search"]').value = ""),
        document
          .querySelector("#predictive-search")
          .classList.remove("results"),
        document.querySelector(".search-not-sugges") &&
          (document
            .querySelector(".search-not-sugges")
            .classList.add("search-hidden"),
          document.documentElement.classList.remove(
            "open-drawer",
            "open-search"
          ),
          root.style.removeProperty("padding-right"));
      let t = document.querySelector("#quick-search");
      t && t.classList.remove("hidden");
    }
    let i = document.querySelector('[aria-selected="true"]');
    i && i.setAttribute("aria-selected", !1),
      document
        .querySelector('input[type="search"]')
        .setAttribute("aria-activedescendant", ""),
      document
        .querySelector('input[type="search"]')
        .setAttribute("aria-expanded", !1),
      (this.resultsMaxHeight = !1),
      document
        .querySelector("[data-predictive-search]")
        .removeAttribute("style"),
      (this.isOpen = !1);
  },
};
BlsSearchShopify.init();
class HeaderSearch extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    let e = this,
      t = this.closest("header");
    if (
      t.classList.contains("popup-search-mobile") &&
      this.classList.contains("search_type_default")
    ) {
      let i = t.dataset.sectionId;
      window.innerWidth < 767 &&
        e.fetchUrl(
          `${window.location.pathname}?section_id=${i}&type=popup&ajax=1`
        );
      let s = window.innerWidth;
      window.addEventListener("resize", function () {
        let t = window.innerWidth;
        t <= 767 &&
          s > 767 &&
          e.fetchUrl(
            `${window.location.pathname}?section_id=${i}&type=popup&ajax=1`
          ),
          t > 767 &&
            s <= 767 &&
            e.fetchUrl(
              `${window.location.pathname}?section_id=${i}&type=default&ajax=1`
            ),
          (s = t);
      });
    }
  }
  fetchUrl(e) {
    fetch(e)
      .then((e) => e.text())
      .then((e) => {
        let t = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("header-search").innerHTML;
        document.querySelector("header-search").innerHTML = t;
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        BlsSearchShopify.init();
      });
  }
}
customElements.define("header-search", HeaderSearch);
class CartNotification extends HTMLElement {
  constructor() {
    super(),
      (this.notification = document.getElementById("header__minicart")),
      (this.giftwrap = document.querySelector(".add-giftwrap")),
      (this.cartCountDown = document.querySelector(".cart-countdown-time")),
      (this.cartUpsellBeside = document.querySelector(
        ".recommendations-beside"
      )),
      (this.startTime = Date.now()),
      this.querySelectorAll(".minicart__wrapper .close-cart-button").forEach(
        (e) => e.addEventListener("click", this.close.bind(this))
      ),
      this.querySelectorAll(".minicart__action").forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault(),
              this.notification
                .querySelector(".minicart__wrapper")
                .classList.contains("open")
                ? this.close()
                : this.open();
          },
          !1
        );
      }),
      (this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]')
      ).reduce((e, t) => e + parseInt(t.value), 0)),
      (this.onBodyClick = this.handleBodyClick.bind(this)),
      (this.debouncedOnChange = debounce((e) => {
        this.onChange(e);
      }, 300)),
      this.addEventListener("change", this.debouncedOnChange.bind(this)),
      this.cartAction(),
      this.addonsUpdate();
  }
  handleBodyClick(e) {
    let t = e.target;
    t == this ||
      t.closest("cart-notification") ||
      t.closest(".cart-quick-edit-modal") ||
      t.closest(".tingle-modal") ||
      this.close();
  }
  cartAction() {
    this.querySelectorAll(".close-cart").forEach((e) => {
      e.addEventListener(
        "click",
        (e) => {
          e.preventDefault(),
            this.notification
              .querySelector(".minicart__wrapper")
              .classList.contains("open") && this.close();
        },
        !1
      );
    }),
      this.querySelectorAll(".cart-addons button").forEach((e) => {
        e.removeEventListener("click", this.cartAddons.bind(this), !1),
          e.addEventListener("click", this.cartAddons.bind(this), !1);
      }),
      document.querySelectorAll(".addon-actions .btn-save").forEach((e) => {
        e.removeEventListener("click", this.cartAddonsSave.bind(this), !1),
          e.addEventListener("click", this.cartAddonsSave.bind(this), !1);
      }),
      this.querySelectorAll(".add-giftwrap").forEach((e) => {
        e.removeEventListener("click", this.addGiftwrapClick.bind(this), !1),
          e.addEventListener("click", this.addGiftwrapClick.bind(this), !1);
      }),
      this.querySelectorAll(".addon-actions .btn-cancel").forEach((e) => {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let t = e.currentTarget;
            t.closest(".cart__addon-content").classList.remove("is-open"),
              t
                .closest(".minicart__wrapper")
                .querySelector(".open")
                .classList.remove("open");
          },
          !1
        );
      });
  }
  addonsUpdate() {
    let e = document.getElementById("address_country"),
      t = document.getElementById("address_province");
    e &&
      t &&
      new Shopify.CountryProvinceSelector(
        "address_country",
        "address_province",
        { hideElement: "address_province_container" }
      );
    let i = document.querySelector(".discount_code"),
      s = localStorage.getItem("discount_code");
    s && i && (document.querySelector(".discount_code").value = s);
  }
  cartAddons(e) {
    e.preventDefault();
    let t = e.currentTarget,
      i = t.getAttribute("data-open");
    if (document.getElementById(i).classList.contains("is-open"))
      document.getElementById(i).classList.remove("is-open"),
        t.classList.remove("open");
    else if (
      (document.getElementById(i).classList.add("is-open"),
      t.classList.add("open"),
      "shipping" == i)
    ) {
      let s = document.getElementById("address_country"),
        r = document.getElementById("address_province");
      s &&
        r &&
        new Shopify.CountryProvinceSelector(
          "address_country",
          "address_province",
          { hideElement: "address_province_container" }
        );
    }
  }
  fetchConfig(e = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${e}`,
      },
    };
  }
  cartAddonsSave(e) {
    e.preventDefault();
    let t = e.currentTarget,
      i = t.getAttribute("data-action");
    if ("coupon" == i) {
      let s = document.querySelector(".discount_code").value;
      localStorage.setItem("discount_code", s),
        document.getElementById(i).classList.remove("is-open"),
        document
          .querySelector(".minicart__wrapper")
          .closest(".minicart__wrapper")
          .classList.remove("open");
    } else if ("note" == i) {
      let r = JSON.stringify({
        note: document.querySelector(".cart-note").value,
      });
      fetch(`${routes?.cart_update_url}`, { ...this.fetchConfig(), body: r }),
        document.getElementById(i).classList.remove("is-open"),
        t
          .closest(".minicart__wrapper")
          .querySelector(".open")
          .classList.remove("open");
    } else if ("shipping" == i) {
      var a = {};
      (a.zip = document.querySelector("#AddressZip").value || ""),
        (a.country = document.querySelector("#address_country").value || ""),
        (a.province = document.querySelector("#address_province").value || ""),
        this._getCartShippingRatesForDestination(a);
    }
  }
  _getCartShippingRatesForDestination(e) {
    fetch(
      `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${e.zip}&shipping_address%5Bcountry%5D=${e.country}&shipping_address%5Bprovince%5D=${e.province}`
    )
      .then((e) => e.text())
      .then((t) => {
        let i = document.querySelector(".addon-message");
        for (var s of document.querySelectorAll(".addon-message p")) s.remove();
        let {
            showDeliveryDays: r,
            deliveryDayOne: a,
            deliveryDaysOther: o,
          } = i.dataset,
          n = JSON.parse(t);
        if (n && n.shipping_rates) {
          if (n.shipping_rates.length > 0) {
            i.classList.remove("error", "warning"), i.classList.add("success");
            let l = document.createElement("p");
            (l.innerText = cartStrings?.shipping_rate.replace(
              "{{address}}",
              e.zip + ", " + e.country + " " + e.province
            )),
              i.appendChild(l),
              n.shipping_rates.map((e) => {
                let t = "";
                if (e.delivery_days.length > 0 && "true" == r) {
                  let s = a,
                    n = e.delivery_days[0],
                    l = e.delivery_days.at(-1);
                  n > 1 && (s = o),
                    (t = n === l ? `(${n} ${s})` : `(${n} - ${l} ${s})`);
                }
                let c = document.createElement("p");
                (c.innerHTML =
                  e.name +
                  ": " +
                  Shopify.formatMoney(e.price, cartStrings?.money_format) +
                  " " +
                  t),
                  i.appendChild(c);
              });
          } else {
            i.classList.remove("error", "success"), i.classList.add("warning");
            let c = document.createElement("p");
            (c.innerText = cartStrings?.no_shipping), i.appendChild(c);
          }
        } else
          i.classList.remove("success", "warning"),
            i.classList.add("error"),
            Object.entries(n).map((e) => {
              let t = `${e[1][0]}`,
                s = document.createElement("p");
              (s.innerText = t), i.appendChild(s);
            });
      })
      .catch((e) => {
        throw e;
      });
  }
  addGiftwrapClick(e) {
    e.preventDefault();
    let t = e.currentTarget,
      i = t.getAttribute("data-variant-id"),
      s = fetchConfig("json");
    (s.body = JSON.stringify({
      id: Number(i),
      quantity: 1,
      sections: this.getSectionsToRender().map((e) => e.id),
      sections_url: window.location.pathname,
    })),
      t.classList.add("loading"),
      fetch(`${routes?.cart_add_url}`, s)
        .then((e) => e.text())
        .then((e) => {
          let t = JSON.parse(e);
          fetch("/cart.json")
            .then((e) => e.json())
            .then((e) => {
              if (void 0 != e.item_count) {
                document.querySelectorAll(".cart-count").forEach((t) => {
                  t.classList.contains("cart-count-drawer")
                    ? (t.innerHTML = `(${e.item_count})`)
                    : (t.innerHTML = e.item_count > 100 ? "~" : e.item_count);
                }),
                  document.querySelector("header-total-price") &&
                    document.querySelector("header-total-price").updateTotal(e);
                let t = document.querySelector("free-ship-progress-bar");
                t && t.init(e.items_subtotal_price);
              }
            })
            .catch((e) => {
              throw e;
            }),
            this.getSectionsToRender().forEach((e) => {
              let i = document.getElementById(e.id),
                s = new DOMParser().parseFromString(
                  t.sections[e.id],
                  "text/html"
                );
              i.innerHTML = s.querySelector("#minicart-form").innerHTML;
            }),
            this.cartAction();
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          document.querySelector(".add-giftwrap").classList.remove("loading");
        });
  }
  onChange(e) {
    "updates[]" == e.target.getAttribute("name") &&
      this.updateQuantity(
        e.target.dataset.id,
        e.target.value,
        e.target.dataset.value,
        e.target,
        document.activeElement.getAttribute("name")
      );
  }
  updateQuantity(e, t, i, s, r) {
    t = t || 0;
    let a = JSON.stringify({
      id: e,
      quantity: t,
      sections: this.getSectionsToRender().map((e) => e.id),
      sections_url: window.location.pathname,
    });
    this.notification.classList.add("start", "loading");
    let o = document.querySelector(".cart-recommend");
    o && o.classList.contains("open") && o.classList.remove("open");
    let n = document.querySelector("free-ship-progress-bar");
    fetch(`${routes?.cart_change_url}`, { ...fetchConfig(), body: a })
      .then((e) => e.text())
      .then((t) => {
        let i = JSON.parse(t);
        if (i.errors) {
          this.updateMessageErrors(e, i.errors, s);
          return;
        }
        if (
          (void 0 != i.item_count &&
            (document.querySelectorAll(".cart-count").forEach((e) => {
              e.classList.contains("cart-count-drawer")
                ? (e.innerHTML = `(${i.item_count})`)
                : (e.innerHTML = i.item_count > 100 ? "~" : i.item_count);
            }),
            document.querySelector("header-total-price") &&
              document.querySelector("header-total-price").updateTotal(i)),
          document.querySelector(".quantity__label"))
        ) {
          var r, a;
          let o = i.items,
            l = document
              .querySelector(".quantity__label")
              .getAttribute("data-pro-id");
          o.forEach(function (e) {
            if ((r = e.variant_id) == l) {
              (document.querySelector(".quantity-cart").innerHTML = e.quantity),
                document
                  .querySelector(".quantity__label")
                  .classList.remove("hidden"),
                (a = l);
              return;
            }
          }),
            a ||
              ((document.querySelector(".quantity-cart").innerHTML = 0),
              document
                .querySelector(".quantity__label")
                .classList.add("hidden"));
        }
        document.querySelector("header-total-price") &&
          document.querySelector("header-total-price").updateTotal(i),
          0 == i.item_count &&
            this.cartCountDown &&
            this.cartCountDown.querySelector("countdown-timer").remove(),
          0 == i.item_count &&
            this.cartUpsellBeside &&
            this.cartUpsellBeside.classList.contains("is-open") &&
            this.cartUpsellBeside.classList.remove("is-open"),
          i.error ||
            void 0 == i.item_count ||
            this.getSectionsToRender().forEach((e) => {
              let t = document.getElementById(e.id),
                s = new DOMParser().parseFromString(
                  i.sections[e.id],
                  "text/html"
                );
              (t.innerHTML = s.querySelector("#minicart-form").innerHTML),
                n && n.init(i.items_subtotal_price);
            }),
          this.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        this.notification.classList.add("finish"),
          setTimeout(function () {
            (this.cart = document.querySelector("cart-notification")),
              this.cart
                .querySelector(".header__minicart")
                .classList.remove("start", "loading", "finish");
          }, 500);
        let e = document.querySelector(".cart-recommend");
        if (e && !e.classList.contains("hidden-recommend")) {
          if (e.classList.contains("cart-recommend-custom")) {
            let t = document.querySelectorAll(".cart-upsell-item"),
              i = document.querySelectorAll(
                ".swiper-cart-upsell .swiper-slide"
              );
            t.length > 0
              ? setTimeout(function () {
                  e.classList.add("open");
                }, 800)
              : 0 === i.length &&
                (e.classList.remove("block"), e.classList.add("hidden"));
          } else
            setTimeout(function () {
              e.classList.add("open");
            }, 800);
        }
      });
  }
  updateMessageErrors(e, t, i) {
    let s = i.dataset.value;
    i.value = s;
    let r = document.getElementById(`CartDrawer-LineItemError-${e}`);
    r && (r.querySelector(".cart-item__error-text").textContent = t);
  }
  open() {
    this.notification.classList.contains("go_to_cart_page")
      ? this.notification.querySelector("a").click()
      : (this.notification
          .querySelector(".minicart__wrapper")
          .classList.add("open"),
        document.documentElement.classList.add("open-drawer", "open-minicart"),
        this.notification.classList.contains("open_drawer") &&
          root.style.setProperty(
            "padding-right",
            getScrollBarWidth.init() + "px"
          ),
        this.notification
          .querySelector(".minicart__action")
          .classList.add("open")),
      this.notification.addEventListener(
        "transitionend",
        () => {
          this.notification.focus();
        },
        { once: !0 }
      ),
      document.body.addEventListener("click", this.onBodyClick);
  }
  close() {
    for (var e of (this.notification
      .querySelector(".minicart__wrapper")
      .classList.remove("open"),
    this.notification.querySelector(".minicart__action").classList.add("open"),
    document.documentElement.classList.remove("open-drawer", "open-minicart"),
    root.style.removeProperty("padding-right"),
    document.querySelector("minicart-recommendations-beside") &&
      document
        .querySelector("minicart-recommendations-beside")
        .classList.remove("open"),
    document.body.removeEventListener("click", this.onBodyClick),
    document.querySelectorAll(".addon")))
      e.classList.remove("is-open");
    for (var e of document.querySelectorAll(".open"))
      e.classList.remove("open");
  }
  getSectionsToRender() {
    return [{ id: "minicart-form" }];
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
customElements.define("cart-notification", CartNotification);
class MinicartItemEdit extends PopupBase {
  constructor() {
    super(),
      this.addEventListener("click", (e) => {
        e.preventDefault();
        let t = this.getAttribute("data-key"),
          i = this.getAttribute("data-quantity"),
          s = this.getAttribute("href"),
          r =
            s.indexOf("?") > -1 ||
            s.indexOf("?variant=") > -1 ||
            s.indexOf("&variant=") > -1
              ? "&"
              : "/?";
        fetch(`${window.shopUrl}${s}${r}section_id=cart-quick-edit`)
          .then((e) => {
            if (!e.ok) {
              var t;
              throw Error(e.status);
            }
            return e.text();
          })
          .then((e) => {
            let t = new DOMParser()
              .parseFromString(e, "text/html")
              .getElementById("shopify-section-cart-quick-edit");
            this.initPopup(
              t,
              `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
            );
          })
          .catch((e) => {
            throw e;
          })
          .finally(() => {
            document.querySelector("[data-template-quick-cart-edit]") &&
              document
                .querySelector("[data-template-quick-cart-edit]")
                .setAttribute("data-line", t),
              document.querySelector(
                ".product-form-quick-edit quantity-input input"
              ) &&
                (document.querySelector(
                  ".product-form-quick-edit quantity-input input"
                ).value = i);
          });
      });
  }
}
customElements.define("minicart-item-edit", MinicartItemEdit);
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      ));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange() {
    this.validateQtyRules();
  }
  onButtonClick(e) {
    e.preventDefault();
    let t = this.input.value;
    "plus" === e.target.name || "plus" === e.target.closest("button").name
      ? this.input.stepUp()
      : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    let e = parseInt(this.input.value);
    if (this.input.min) {
      let t = parseInt(this.input.min),
        i = this.querySelector(".quantity__button[name='minus']");
      i.classList.toggle("disabled", e <= t);
    }
    if (this.input.max) {
      let s = parseInt(this.input.max),
        r = this.querySelector(".quantity__button[name='plus']");
      r.classList.toggle("disabled", e >= s);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
class ProgressBar extends HTMLElement {
  constructor() {
    super();
    let e = this.dataset.order;
    this.init(e);
  }
  init(e) {
    let t = this.dataset.feUnavaiable,
      i = this.dataset.feAvaiable,
      s = Number(Shopify.currency.rate),
      r = Number(this.dataset.feAmount);
    if (!r || !s) return;
    let a = Number(e) / 100,
      o = r * s;
    void 0 != a &&
      ((a / o) * 100 > 100
        ? this.setProgressBar(100)
        : this.setProgressBar((a / o) * 100),
      this.setProgressBarTitle(a, o, t, i));
  }
  setProgressBarTitle(e, t, i, s) {
    let r = this.querySelector(".free-shipping-message");
    r &&
      (r.classList.remove("opacity-0"),
      e >= t
        ? (r.innerHTML = s)
        : (r.innerHTML = i.replace(
            "{{ amount }}".trim(),
            Shopify.formatMoney((t - e) * 100, cartStrings.money_format)
          )));
  }
  setProgressBar(e) {
    let t = this.querySelector(".progress");
    (t.style.width = e + "%"),
      100 === e
        ? this.classList.add("cart_shipping_free")
        : this.classList.remove("cart_shipping_free");
  }
}
customElements.define("free-ship-progress-bar", ProgressBar);
let BlsMainMenuShopify = {
  init: function () {
    this.initMenu(), this.initMainMenu(), this.initVerticalMenu();
  },
  initMenu: function () {
    let e = document.querySelector(".categories-list-menu-mobile"),
      t = document.querySelector('[data-menu="categories-list"]'),
      i = document.querySelector('[data-menu="verticalmenu-list"]'),
      s = document.querySelector(".verticalmenu-mobile"),
      r = document.querySelector(".horizontal-list"),
      a = window.innerWidth;
    function o(a) {
      a <= 1024
        ? (((r && t?.classList.contains("active")) ||
            i?.classList.contains("active")) &&
            (r.style.display = "none"),
          s && i.classList.contains("active") && (s.style.display = "block"))
        : (e && t.classList.contains("active") && (e.style.display = "none"),
          s && i.classList.contains("active") && (s.style.display = "none"),
          ((r && t?.classList.contains("active")) ||
            i?.classList.contains("active")) &&
            (r.style.display = "inline-flex"));
    }
    HoverIntent(document.querySelectorAll(".menu-parent"), {
      onEnter: function (e) {
        e.classList.add("visible");
      },
      onExit: function (e) {
        e.classList.remove("visible");
      },
    }),
      window.addEventListener("resize", function () {
        o(a);
      }),
      document.querySelectorAll(".menu-mobile-title a").forEach((t) => {
        t.addEventListener(
          "click",
          (t) => {
            t.preventDefault();
            let i = t.currentTarget,
              a = i.dataset.menu;
            for (var o of document.querySelectorAll(".menu-mobile-title a"))
              o.classList.remove("active");
            i.classList.add("active"),
              "categories-list" == a
                ? ((r.style.display = "none"), (e.style.display = "block"))
                : "verticalmenu-list" == a
                ? ((r.style.display = "none"), (s.style.display = "block"))
                : ((r.style.display = "block"),
                  e && (e.style.display = "none"),
                  s && (s.style.display = "none"));
          },
          !1
        );
      }),
      o(a);
  },
  initMainMenu: function () {
    var e = this;
    let t = document.querySelector("header"),
      i = t?.getAttribute("data-sticky"),
      s = t?.getAttribute("data-sticky-mobile"),
      r = document.querySelector(".verticalmenu-list"),
      a = document.querySelector(".navigation.horizontal");
    if (
      (document.querySelectorAll(".nav-toggle").forEach((e) => {
        e.addEventListener("click", (e) => {
          let t = e.currentTarget;
          document.documentElement.classList.contains("nav-open")
            ? (root.style.removeProperty("padding-right"),
              document.documentElement.classList.remove("nav-open"),
              t.classList.remove("open"),
              a ||
                document.documentElement.classList.remove("nav-verticalmenu"))
            : (root.style.setProperty(
                "padding-right",
                getScrollBarWidth.init() + "px"
              ),
              document.documentElement.classList.add("nav-open"),
              t.classList.add("open"),
              a || document.documentElement.classList.add("nav-verticalmenu"));
        });
      }),
      r && a)
    ) {
      let o = document.querySelector(".verticalmenu-html"),
        n = o.dataset.limitshowitem,
        l =
          '<a data-menu="verticalmenu-list" href="#">' +
          window.menuStrings?.verticalTitle +
          "</a>",
        c = document.querySelector(".verticalmenu-list").innerHTML,
        d = document.createElement("ul");
      d.classList.add("verticalmenu-list"),
        d.classList.add("verticalmenu-mobile"),
        (d.style.display = "none"),
        d.setAttribute("data-limitshowitem", n),
        (d.innerHTML = c),
        a.querySelector(".mobile-menu-content").appendChild(d),
        a
          .querySelector(".menu-mobile-title")
          .insertAdjacentHTML("beforeend", l);
    }
    let u = screen.width;
    document.querySelectorAll("li.menu-parent .submenu").forEach((e, t) => {
      u > 1024 &&
        (e.addEventListener("mouseenter", (e) => {
          let t = e.currentTarget;
          t.closest(".menu-parent").classList.add("active-submenu");
        }),
        e.addEventListener("mouseleave", (e) => {
          let t = e.currentTarget;
          t.closest(".menu-parent").classList.remove("active-submenu");
        }));
    });
let announcementBarEl = document.querySelector(".section-announcement-bar");
let topBarEl = document.querySelector(".section-top-bar");
let headerEl = document.querySelector("header");
let h = announcementBarEl ? announcementBarEl.clientHeight : 0;
let p = topBarEl ? topBarEl.clientHeight : 0;
let m = headerEl ? headerEl.clientHeight : 0;
    if (
      (document
        .querySelector("body")
        .setAttribute(
          "style",
          "--height-bar: " +
            h +
            "px;--height-header: " +
            m +
            "px;--height-topbar: " +
            p +
            "px "
        ),
      t && "none" != i)
    ) {
      if ("false" == s && window.innerWidth < 1025) return;
      let y = h + p + document.getElementById("header-sticky")?.offsetHeight,
        v = 0,
        g = t.closest(".section-header");
      "on-scroll-up" === i && g.classList.add("scroll-up");
      let scrollTicking = false;
      window.addEventListener(
        "scroll",
        () => {
          if (scrollTicking) return;
          scrollTicking = true;
          requestAnimationFrame(() => {
            let e;
            (e = window.scrollY),
              g &&
                ("always" === i
                  ? e > y
                    ? g.classList.add(
                        "shopify-section-header-sticky",
                        "animate"
                      )
                    : g.classList.remove(
                        "shopify-section-header-sticky",
                        "animate"
                      )
                  : e > 0
                  ? e > y
                    ? (g.classList.add("scr-pass-header"),
                      e > v
                        ? g.classList.add("shopify-section-header-hidden")
                        : (g.classList.remove("shopify-section-header-hidden"),
                          g.classList.add("animate")),
                      g.classList.add("header-sticky"),
                      g.classList.add("shopify-section-header-sticky"),
                      (v = e))
                    : (g.classList.remove("header-sticky"),
                      g.classList.remove("scr-pass-header"),
                      (v = 0))
                  : (g.classList.remove(
                      "shopify-section-header-hidden",
                      "header-sticky"
                    ),
                    g.classList.remove(
                      "animate",
                      "shopify-section-header-sticky"
                    )));
            scrollTicking = false;
          });
        },
        { passive: true }
      );
    }
    if (a) {
      let f = window.innerWidth;
      f > 1024 && e.addCssSubMenu();
      let resizeTimer;
      window.addEventListener(
        "resize",
        function (t) {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            f > 1024 && e.addCssSubMenu();
          }, 150);
        },
        !0
      );
    }
  },
  initVerticalMenu: function () {
    let e = screen.width,
      t = document.querySelector(".verticalmenu-html");
    if (null === t) return;
    let i = t.dataset.limitshowitem,
      s = document.querySelectorAll(".verticalmenu-html .level0").length;
    if (e > 1024) {
      if (s > i) {
        var r = Array.from(
          document.querySelectorAll(".verticalmenu-html .level0")
        );
        r.forEach((e, t) => {
          if (t > i - 1) {
            let s = r[t];
            !s.classList.contains("expand-menu-link") &&
              (s.classList.add("orther-link"), (s.style.display = "none"));
          }
        }),
          (document.querySelector(
            ".verticalmenu-html .expand-menu-link"
          ).style.display = "block"),
          document
            .querySelector(".verticalmenu-html .expand-menu-link a")
            .addEventListener(
              "click",
              (e) => {
                e.preventDefault();
                let t = e.currentTarget,
                  i = t.parentElement;
                if (i.classList.contains("expanding"))
                  for (var s of (i.classList.remove("expanding"),
                  (i.querySelector("a").innerHTML =
                    window.menuStrings?.moreMenus),
                  document.querySelectorAll(
                    ".verticalmenu-html .level0.orther-link"
                  )))
                    hideAnime(s);
                else
                  for (var s of (i.classList.add("expanding"),
                  (i.querySelector("a").innerHTML =
                    window.menuStrings?.hideMenus),
                  document.querySelectorAll(
                    ".verticalmenu-html .level0.orther-link"
                  )))
                    showAnime(s);
              },
              !1
            );
      } else document.querySelector(".expand-menu-link").style.display = "none";
    }
    document.querySelector(".vertical_menu .title-menu-dropdown") &&
      document
        .querySelector(".vertical_menu .title-menu-dropdown")
        .addEventListener("click", (e) => {
          e.preventDefault();
          let t = e.currentTarget,
            i = t.closest(".vertical-menu");
          i.classList.contains("open")
            ? i.classList.remove("open")
            : i.classList.add("open");
        });
  },
addCssSubMenu: function () {
  let e = document.documentElement.clientWidth || document.body.clientWidth,
    t = document.querySelector("header"),
    i = document.querySelector(".submenu-center");
  if (t && !(e < 1024)) {
    const items = document.querySelectorAll(".horizontal-list .mega-menu-fix-width");
    const measurements = [];
    items.forEach((el) => {
      if (i) {
        const s = el.getBoundingClientRect();
        measurements.push({ el, type: "center", width: s.width, left: s.left, right: s.right });
      } else {
        measurements.push({ el, type: "edge", width: el.clientWidth, left: el.offsetLeft });
      }
    });
    measurements.forEach((m) => {
      if (m.type === "center") {
        if (800 <= m.width) {
          m.el.style.left = (m.left - (m.right - e)) / 2 + "px";
        }
      } else {
        if (e - (m.width + m.left) < 0) {
          let c = e - (m.width + m.left);
          c = c + m.left - 30;
          if (m.left < 0) c = 0;
          m.el.style.left = c + "px";
        }
      }
    });
  }
},
};
BlsMainMenuShopify.init();
class OpenChildrenToggle extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", this.onToggle.bind(this), !1);
  }
  onToggle() {
    let e = this.parentElement;
    e &&
      (e.classList.contains("is-open")
        ? e.classList.remove("is-open")
        : e.classList.add("is-open"));
  }
}
customElements.define("open-children-toggle", OpenChildrenToggle);
class CloseMenu extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", this.onClose.bind(this), !1);
  }
  onClose() {
    document.documentElement.classList.remove("nav-open"),
      document.querySelector(".nav-toggle").classList.remove("open"),
      document.querySelectorAll("menu-item").forEach((e) => {
        e.classList.remove("is-open");
      });
  }
}
customElements.define("close-menu", CloseMenu);
class ReviewProduct extends HTMLElement {
  constructor() {
    super(), (this.productHandle = this.dataset.productHandle), this.init();
  }
  init() {
    if (
      this.classList.contains("review-product-added") &&
      !document.body.classList.contains("index")
    ) {
      this.fetchDataReviewProduct();
      return;
    }
    let observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.fetchDataReviewProduct();
            obs.unobserve(this);
          }
        });
      },
      { rootMargin: "0px 0px 400px 0px" }
    );
    observer.observe(this);
  }
  fetchDataReviewProduct() {
    this.classList.contains("review-product-added") &&
      (this.classList.remove("review-product-added"),
      (this.innerHTML = this.querySelector(".product-review-json").innerHTML),
      this.classList.remove("inline-loading"));
  }
}
customElements.define("review-product", ReviewProduct);
class BackMenu extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", this.onBackMenu.bind(this), !1);
  }
  onBackMenu() {
    this.classList.contains("back-lv1")
      ? this.closest(".level-1")
          .querySelector("menu-item")
          .classList.remove("is-open")
      : this.closest(".level0")
          .querySelector("menu-item")
          .classList.remove("is-open");
  }
}
customElements.define("back-menu", BackMenu);
var BlsLoginPopup = {
  init: function () {
    this.showLogin();
  },
  clickTab: function (e) {
    let t = document.querySelectorAll("[data-login-hidden]"),
      i = document.querySelectorAll("[data-login-show]"),
      s = document.querySelector("#login-popup .login-heading");
    i.forEach((e) => {
      var i = e?.dataset.loginShow;
      e.addEventListener("click", function (e) {
        e.preventDefault(),
          t.forEach((e) => {
            var t = e?.dataset.loginHidden;
            "true" === e.getAttribute("aria-hidden") && i === t
              ? (e.setAttribute("aria-hidden", "false"), s && (s.innerText = i))
              : e.setAttribute("aria-hidden", "true");
          });
      });
    });
  },
  showLogin: function () {
    let e = document.querySelector(".action-login-popup"),
      t = this;
    e &&
      e.addEventListener("click", (e) => {
        e.preventDefault(), t.fetchDataLogin();
      });
  },
  fetchDataLogin: function () {
    let e = `${window.location.pathname}?section_id=login-popup`,
      t = this;
    fetch(e)
      .then((e) => e.text())
      .then((e) => {
        let i = parser.parseFromString(e, "text/html"),
          s = i.querySelector("#login-popup");
        if (s) {
          let r = new tingle.modal({
            footer: !1,
            stickyFooter: !1,
            closeMethods: ["overlay", "button", "escape"],
            closeLabel: "Close",
            cssClass: ["login-popup-modal"],
            onOpen: function () {},
            onClose: function () {},
            beforeClose: function () {
              return !0;
            },
          });
          r.setContent(s),
            r.open(),
            document
              .querySelectorAll(".login__popup-button-close")
              .forEach((e) => {
                e.addEventListener(
                  "click",
                  (e) => {
                    e.preventDefault(), r.close();
                  },
                  !1
                );
              });
        }
        t.clickTab();
      })
      .catch((e) => {
        throw e;
      });
  },
};
BlsLoginPopup.init();
class BackToTop extends HTMLElement {
  constructor() {
  super(), this.addEventListener("click", this.backToTop.bind(this), !1);
  }
connectedCallback() {
    this._ticking = false;
    this._onScroll = () => {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this.updateScrollPercentage();
        this._ticking = false;
      });
    };
    window.addEventListener("scroll", this._onScroll, { passive: true });
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this._onScroll);
  }
  backToTop() {
    (document.documentElement.scrollTop > 0 || document.body.scrollTop > 0) &&
      window.scrollTo({ top: 0, behavior: "smooth" });
  }
  updateScrollPercentage() {
    let e = document.documentElement.scrollHeight || document.body.scrollHeight,
      t = document.documentElement.scrollTop || document.body.scrollTop,
      i = document.documentElement.clientHeight || document.body.clientHeight;
    this.style.setProperty("--height", ((t / (e - i)) * 100).toFixed(2) + "%"),
      t > 200 ? this.classList.add("show") : this.classList.remove("show");
  }
}
customElements.define("back-to-top", BackToTop);
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        input: this.querySelector(
          'input[name="language_code"], input[name="country_code"]'
        ),
        button: this.querySelector(".button-localization"),
        panel: this.querySelector("ul"),
      }),
      this.elements.button.addEventListener(
        "click",
        this.openSelector.bind(this)
      ),
      this.elements.button.addEventListener(
        "focusout",
        this.closeSelector.bind(this)
      ),
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
      this.querySelectorAll("a").forEach((e) =>
        e.addEventListener("click", this.onItemClick.bind(this))
      ),
      (this.onBodyClick = this.handleBodyClick.bind(this));
  }
  handleBodyClick(e) {
    let t = e.target;
    t == this || t.closest("localization-form") || this.hidePanel();
  }
  hidePanel() {
    document.body.removeEventListener("click", this.onBodyClick),
      this.elements.button.classList.remove("open");
  }
  onContainerKeyUp(e) {
    "ESCAPE" === e.code.toUpperCase() &&
      (this.hidePanel(), this.elements.button.focus());
  }
  onItemClick(e) {
    e.preventDefault();
    let t = this.querySelector("form");
    (this.elements.input.value = e.currentTarget.dataset.value),
      t && t.submit();
  }
  openSelector() {
    if (this.elements.button.classList.contains("open")) this.hidePanel();
    else {
      for (var e of (document.body.addEventListener("click", this.onBodyClick),
      this.elements.button.focus(),
      document.querySelectorAll(".button-localization")))
        e.classList.remove("open");
      this.elements.button.classList.add("open");
    }
  }
  closeSelector(e) {
    let t = e.relatedTarget && "BUTTON" === e.relatedTarget.nodeName;
    (null === e.relatedTarget || t) && this.hidePanel();
  }
}
customElements.define("localization-form", LocalizationForm);
class CollapsibleBlock extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const block = _this.querySelectorAll(".collapsible-heading");
    block.forEach((event) => {
      event.addEventListener("click", (e) => {
        const target = e.currentTarget;
        const parent = target.parentElement;
        const footerContent = parent.querySelector(".collapsible-content");
        if (
          _this.closest(".collection-filter") &&
          _this
            .closest(".collection-filter")
            .classList.contains("horizontal") &&
          window.innerWidth > 1024
        ) {
          if (!_this.classList.contains("active")) {
            if (document.querySelector("collapsible-block.active")) {
              document
                .querySelector("collapsible-block.active")
                .classList.remove("active");
            }
            _this.classList.add("active");
          } else {
            _this.classList.remove("active");
          }
        } else {
          slideAnime({
            target: footerContent,
            animeType: "slideToggle",
          });
          if (!_this.classList.contains("active")) {
            _this.classList.add("active");
          } else {
            _this.classList.remove("active");
          }
        }
      });
    });
    CollapsibleBlock.registerDelegatedOutsideClick();
    var width = window.innerWidth;
    const footerContent = this.querySelector(".collapsible-content");
    if (width <= 1024) {
      if (!this.classList.contains("open_always")) {
        this.classList.remove("active");
      } else {
        footerContent.style.display = "block";
      }
    } else {
      this.classList.add("active");
      footerContent.style.display = "block";
    }
    window.addEventListener("resize", () => {
      const footerContent = this.querySelector(".collapsible-content");
      var width = window.innerWidth;
      if (width <= 1024) {
        if (!this.classList.contains("open_always")) {
          this.classList.remove("active");
        } else {
          footerContent.style.display = "block";
        }
      } else {
        this.classList.add("active");
        footerContent.style.display = "block";
      }
    });

    if (this.classList.contains("collection")) {
      this.actionInMobile();
      window.addEventListener("resize", () => {
        this.actionInMobile();
      });
    }
  }

  // Single, shared, delegated document-level click listener for ALL
  // collapsible-block instances, instead of one listener per instance.
  // This is registered once no matter how many <collapsible-block>
  // elements exist on the page (e.g. many filter groups in a sidebar).
  static registerDelegatedOutsideClick() {
    if (CollapsibleBlock._delegatedListenerAdded) return;
    CollapsibleBlock._delegatedListenerAdded = true;
    document.body.addEventListener("click", (evt) => {
      const target = evt.target;
      const filterEl = document.querySelector(".collection-filter");
      if (
        !target.closest("collapsible-block") &&
        filterEl &&
        filterEl.classList.contains("horizontal") &&
        window.innerWidth > 1024
      ) {
        filterEl.querySelectorAll("collapsible-block").forEach((collapsible) => {
          collapsible.classList.remove("active");
        });
      }
    });
  }

  actionInMobile() {
    var _this = this;
    var width = window.innerWidth;
    if (width <= 1024) {
      const footerContent = _this.querySelector(".collapsible-content");
      footerContent.style.display = "block";
      _this.classList.add("active");
    }
  }
}
customElements.define("collapsible-block", CollapsibleBlock);
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    let e = this,
      t = e.querySelector(".announcement-bar-close");
    t.addEventListener("click", (t) => {
      slideAnime({ target: e, animeType: "slideToggle" }),
        sessionStorage.setItem("announcement_bar", "false");
    });
  }
}
customElements.define("announcement-bar", AnnouncementBar);
class VideoSection extends HTMLElement {
  constructor() {
    super(),
      (this.thumb = this.querySelector(".video-thumbnail")),
      (this.video_iframe = this.querySelector(".video-has-bg iframe")),
      this.init();
  }
  init() {
    this.video_iframe &&
      this.video_iframe.addEventListener("load", () => {
        this.thumb && this.thumb.remove();
      });
  }
}
customElements.define("video-section", VideoSection);
class AgeVerifier extends HTMLElement {
  constructor() {
    super(),
      (this.ageVerifyDetail = this.querySelector(".age-verify-detail")),
      (this.declineVerifyDetail = this.querySelector(".decline-verify-detail")),
      this.init(),
      this.mainFunction();
  }
  init() {
    Shopify.designMode ||
      (getCookie("age_verifier")
        ? "false" == getCookie("age_verifier")
          ? (this.classList.add("active"),
            this.declineVerifyDetail.classList.remove("hidden"),
            this.ageVerifyDetail.classList.add("hidden"))
          : this.remove()
        : (this.classList.add("active"),
          this.declineVerifyDetail.classList.add("hidden"),
          this.ageVerifyDetail.classList.remove("hidden")));
  }
  mainFunction() {
    let e = this.querySelector(".age-verifier-approve"),
      t = this.querySelector(".age-verifier-decline"),
      i = this.querySelector(".age-verifier-return");
    i && i.addEventListener("click", () => this.handleReturn()),
      e &&
        t &&
        (e.addEventListener("click", () => this.handleApprove()),
        t.addEventListener("click", () => this.handleDecline()));
  }
  handleReturn() {
    Shopify.designMode ||
      (setCookie("age_verifier", "false", "-1"), this.init());
  }
  handleDecline() {
    Shopify.designMode ||
      (setCookie("age_verifier", "false", "365"), this.init());
  }
  handleApprove() {
    setCookie("age_verifier", "true", "false"),
      this.classList.add("fadeOut"),
      setTimeout(() => {
        this.remove();
      }, 1e3);
  }
}
customElements.define("age-verifier", AgeVerifier);
class PromotionPopup extends HTMLElement {
  constructor() {
    super(),
      setTimeout(() => {
        this.init();
      }, 6e3);
  }
  init() {
    let e = this?.dataset.show,
      t = "true" === this?.dataset.showMb;
    if (
      !Shopify.designMode &&
      ("show-on-all-pages" === e || "show-on-homepage" === e) &&
      "" === getCookie("promotion-popup")
    ) {
      let i = new tingle.modal({
        footer: !1,
        stickyFooter: !1,
        closeMethods: ["overlay", "button", "escape"],
        closeLabel: "Close",
        cssClass: [
          "promotion-popup-modal",
          `${t ? "enable-on-mobile" : "show-all"}`,
        ],
      });
      i.setContent(this.innerHTML),
        i.open(),
        this.copyPromotion(),
        this.checkNotShowPromotion();
    }
  }
  checkNotShowPromotion() {
    let e = document.querySelector(".promotion-popup-modal .do-not-show-again");
    e &&
      e.addEventListener("click", (e) => {
        setCookie("promotion-popup", 1, 1),
          document
            .querySelector(".promotion-popup-modal .tingle-modal__close")
            .click();
      });
  }
  copyPromotion() {
    let e = document.querySelectorAll(".promotion-popup-modal .discount");
    null !== e &&
      e.forEach((e) => {
        e.addEventListener("click", (t) => {
          t.preventDefault(),
            navigator.clipboard.writeText(e?.dataset.code),
            e.classList.add("action-copy"),
            setTimeout(() => {
              e.classList.remove("action-copy");
            }, 1500);
        });
      });
  }
}
customElements.define("promotion-popup", PromotionPopup);
class NewsletterPopup extends HTMLElement {
  constructor() {
    super(),
      setTimeout(() => {
        this.init();
      }, 2e3);
  }
  init() {
    let e = this.dataset.sectionId,
      t = `${window.location.pathname}?section_id=${e}&ajax=1`;
    fetch(`${t}`)
      .then((e) => {
        if (!e.ok) throw Error(e.status);
        return e.text();
      })
      .then((e) => {
        let t = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("newsletter-popup").innerHTML;
        document.querySelector("newsletter-popup").innerHTML = t;
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        this.initPopup();
      });
  }
  initPopup() {
    let e = this?.dataset.show,
      t = "true" === this?.dataset.showMb;
    if (!Shopify.designMode) {
      let i = getCookie("newsletter_popup"),
        s = window.innerWidth;
      if (!t && s < 768) return !1;
      if (("show_homepage" == e || "show_all_page" == e) && "" === i) {
        let r = new tingle.modal({
          footer: !1,
          stickyFooter: !1,
          closeMethods: ["overlay", "button", "escape"],
          closeLabel: "Close",
          cssClass: [
            "newsletter-popup-modal",
            `${t ? "show-all" : "disable-on-mobile"}`,
          ],
        });
        r.setContent(this.innerHTML), r.open(), this.onShowNewletter();
      }
    }
  }
  onShowNewletter() {
    let e = this,
      t = document.querySelector(
        ".newsletter-popup-modal .newsletter-popup__dont-show"
      );
    t &&
      (t.addEventListener("click", e.notShow.bind(e)),
      t.addEventListener(
        "keypress",
        function (t) {
          "Enter" === t.key && e.notShow.bind(e)(t);
        }.bind(e),
        !1
      ));
  }
  notShow(e) {
    e.preventDefault(),
      setCookie("newsletter_popup", 30, 1),
      document
        .querySelector(".newsletter-popup-modal .tingle-modal__close")
        .click();
  }
}
customElements.define("newsletter-popup", NewsletterPopup);
var returnMessageWhenSubmit = {
  init: function () {
    this.checkUrlReturn();
  },
  checkUrlReturn: function () {
    let e = window.location.href;
    if (
      e.indexOf("customer_posted=true#newsletter-form") >= 1 ||
      e.indexOf("customer_posted=true") >= 1
    ) {
      this.handleMessageSuccessPopup(), setCookie("newsletter_popup", 30, 1);
      let t = location.href.split("?")[0];
      window.history.pushState("object", document.title, t);
    }
    if (e.indexOf("contact%5Btags%5D=newsletter&form_type=customer") >= 1) {
      this.handleMessageErrorPopup();
      let i = location.href.split("?")[0];
      window.history.pushState("object", document.title, i);
    }
  },
  handleMessageSuccessPopup: function () {
    let e = `${window.location.pathname}?section_id=form-message`;
    fetch(e)
      .then((e) => e.text())
      .then((e) => {
        let t = new DOMParser().parseFromString(e, "text/html"),
          i = t.querySelector(".newsletter-form__success-message-wrapper");
        i.querySelector(".newsletter-form__message"),
          showToast(i.innerHTML, 5e3, "modal-success");
      })
      .catch((e) => {
        throw e;
      });
  },
  handleMessageErrorPopup: function () {
    let e = `${window.location.pathname}?section_id=form-message`;
    fetch(e)
      .then((e) => e.text())
      .then((e) => {
        let t = new DOMParser().parseFromString(e, "text/html"),
          i = t.querySelector(".newsletter-form__error-message-wrapper");
        i.querySelector(".newsletter-form__message"),
          showToast(i.innerHTML, 5e3, "modal-error");
      })
      .catch((e) => {
        throw e;
      });
  },
};
returnMessageWhenSubmit.init();
class NavBar extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    document.body.classList.add("mobi-navigation-bar");
  }
}
customElements.define("mobile-navigation-bar", NavBar);
class IconBox extends SlideSection {
  constructor() {
    super(),
      (this.enable = this.dataset.enable),
      (this.swiperSlideInnerHtml = this.innerHTML),
      this.init();
  }
  init() {
    if ("true" == this.enable) {
      let e = window.innerWidth;
      window.addEventListener("resize", () => {
        let t = window.innerWidth;
        t <= 767 && e > 767 && this.actionOnMobile(),
          t > 767 && e <= 767 && this.actionOutMobile(),
          (e = t);
      }),
        e <= 767 ? this.actionOnMobile() : this.actionOutMobile();
    }
  }
  actionOnMobile() {
    this.classList.add("swiper"), this.classList.remove("grid", "grid-cols");
    let e = this.swiperSlideInnerHtml.replaceAll(
        "sec__icon-switch-slide",
        "swiper-slide"
      ),
      t = `<div class='swiper-wrapper'>${e}</div> <div
    class="swiper-pagination  ${
      this.enable && 1.5 != this.dataset.mobile ? "flex" : "hidden"
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    (this.innerHTML = t), this.initSlide();
  }
  actionOutMobile() {
    this.classList.remove("swiper"),
      this.classList.add("grid", "grid-cols"),
      (this.innerHTML = this.swiperSlideInnerHtml);
  }
}
customElements.define("icon-box", IconBox);
class PaginateLoadmore extends HTMLElement {
  maxBatches = 3;
  constructor() {
    super(),
      (this.batches = []),
      (this.isFetching = false),
      (this.pauseObservers = false),
      this.initLoadMore(),
      this.classList.contains("collection-infinite-scroll") &&
        this.querySelector("a").addEventListener(
          "click",
          (e) => {
            for (var t of document.querySelectorAll(
              ".sec__collections-list .collection-item.grid-custom-item"
            ))
              t.classList.remove("hidden");
            this.remove();
          },
          !1
        );
  }
  initLoadMore() {
    this.querySelectorAll(".actions-loadmore").forEach((e) => {
      var t = this;
      if (e.classList.contains("infinit-scrolling")) {
        let initialItems = Array.from(
          document.querySelectorAll(".loadmore-lists .loadmore-item")
        );
        if (initialItems.length) this.batches.push(initialItems);
        this.observeTriggerItem(e, initialItems);
        this.observeFallbackButton(e);
      } else {
        e.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            let i = e.currentTarget;
            t.loadMoreItem(i);
          },
          !1
        );
      }
    });
  }
  observeTriggerItem(triggerEl, batchItems) {
    if (!batchItems || !batchItems.length) return;
    if (this._itemObserver) this._itemObserver.disconnect();
    let triggerIndex = Math.min(9, batchItems.length - 1);
    let triggerItem = batchItems[triggerIndex];
    if (!triggerItem) return;
    this._itemObserver = new IntersectionObserver(
      (entries, obs) => {
        if (this.pauseObservers || this.isFetching) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            obs.disconnect();
            this.loadMoreItem(triggerEl);
          }
        });
      },
      { rootMargin: "0px 0px 1000px 0px", threshold: 0 }
    );
    this._itemObserver.observe(triggerItem);
  }
  observeFallbackButton(triggerEl) {
    if (this._fallbackObserver) this._fallbackObserver.disconnect();
    this._fallbackObserver = new IntersectionObserver(
      (entries, obs) => {
        if (this.pauseObservers || this.isFetching) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            obs.disconnect();
            if (this._itemObserver) this._itemObserver.disconnect();
            this.loadMoreItem(triggerEl);
          }
        });
      },
      { threshold: 0 }
    );
    this._fallbackObserver.observe(triggerEl);
  }
  loadMoreItem(e) {
    if (this.isFetching) return;
    this.isFetching = true;

    let t = e.getAttribute("href"),
      i = this;
    i.toggleLoading(e, !0),
      fetch(`${t}`)
        .then((e) => {
          if (!e.ok) throw Error(e.status);
          return e.text();
        })
        .then((t) => {
          let s = parser.parseFromString(t, "text/html"),
            r = s.querySelectorAll(".loadmore-lists .loadmore-item");
          let newBatch = [];
          r.forEach((el) => {
            document.querySelector(".loadmore-lists").appendChild(el);
            newBatch.push(el);
          });
          this.batches.push(newBatch);

          let a = s.querySelector(".actions-loadmore");
          document.querySelector(".load-more-bar").innerHTML =
            s.querySelector(".load-more-bar").innerHTML;
          if (a) {
            e.setAttribute("href", a.getAttribute("href"));
          }
          i.toggleLoading(e, !1);

          this.pruneOldBatch();

          if (e.classList.contains("infinit-scrolling") && newBatch.length) {
            this.pauseObservers = true;
            requestAnimationFrame(() => {
              this.observeTriggerItem(e, newBatch);
              this.observeFallbackButton(e);
              setTimeout(() => {
                this.pauseObservers = false;
              }, 150);
            });
          }

          if (!a) e.remove();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          initLazyloadItem();
          this.isFetching = false;
        });
  }
  pruneOldBatch() {
    while (this.batches.length > this.maxBatches) {
      let oldest = this.batches.shift();
      if (!oldest || !oldest.length) continue;

      let scrollEl = document.scrollingElement || document.documentElement;
      let scrollHeightBefore = scrollEl.scrollHeight;

      oldest.forEach((el) => el.remove());

      let scrollHeightAfter = scrollEl.scrollHeight;
      let removedHeight = scrollHeightBefore - scrollHeightAfter;

      if (removedHeight > 0) {
        window.scrollBy(0, -removedHeight);
      }
    }
  }
  toggleLoading(e, t) {
    e && e.classList[t ? "add" : "remove"]("loading");
  }
}
customElements.define("loadmore-button", PaginateLoadmore);

// Prevent the browser's native "scroll anchoring" from ALSO compensating
// scroll position when items are removed above the viewport — otherwise it
// stacks with our manual compensation in pruneOldBatch() and overcorrects.
(function () {
  let container = document.querySelector(".loadmore-lists");
  if (container) {
    container.style.overflowAnchor = "none";
  }
})();
class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then((e) => e.text())
      .then((e) => {
        let t = document.createElement("div");
        t.innerHTML = e;
        let i = t.querySelector(".swiper-wrapper");
        i && i.innerHTML.trim().length
          ? this.querySelector(".swiper-wrapper") &&
            (this.querySelector(".swiper-wrapper").innerHTML = i.innerHTML)
          : this.classList.add("hidden");
      })
      .finally(() => {})
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("minicart-recommendations", CartUpsell);
class CartUpsellBeside extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then((e) => e.text())
      .then((e) => {
        let t = document.createElement("div");
        t.innerHTML = e;
        let i = t.querySelector(".cart-upsell-wrapper");
        i && i.innerHTML.trim().length
          ? this.querySelector(".cart-upsell-wrapper") &&
            (this.querySelector(".cart-upsell-wrapper").innerHTML = i.innerHTML)
          : this.classList.add("hidden");
      })
      .finally(() => {})
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("minicart-recommendations-beside", CartUpsellBeside);
class CartUpsellHeading extends HTMLElement {
  constructor() {
    super(),
      this.querySelector(".button-close-beside") &&
        this.querySelector(".button-close-beside").addEventListener(
          "click",
          (e) => {
            let t = e.currentTarget,
              i = t.closest(".cart-recommend");
            i.classList.remove("open");
          },
          !1
        );
  }
}
customElements.define("minicart-recommendations-heading", CartUpsellHeading);
class ShowPassWord extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this));
  }
  onClick() {
    var e = this.closest(".form-field").querySelector("input");
    "password" === e.type
      ? ((e.type = "text"), this.classList.add("text"))
      : ((e.type = "password"), this.classList.remove("text"));
  }
}
customElements.define("show-pass-word", ShowPassWord);
class BeforeYouLeave extends HTMLElement {
  constructor() {
    super(),
      setTimeout(() => {
        this.init();
      }, 1e4);
  }
  init() {
    let e = this.dataset.sectionId,
      t = `${window.location.pathname}?section_id=${e}&ajax=1`;
    fetch(`${t}`)
      .then((e) => {
        if (!e.ok) throw Error(e.status);
        return e.text();
      })
      .then((e) => {
        let t = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("before-you-leave").innerHTML;
        document.querySelector("before-you-leave").innerHTML = t;
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        this.initPopup();
      });
  }
  initPopup() {
    let e = document.querySelector("before-you-leave"),
      t = e?.dataset.timeDelay;
    if (null !== e) {
      // Exit-intent trigger: instead of a permanent global mousemove/scroll/
      // click/keydown listener stack (which fires dozens of times per
      // second and hurts INP for the whole site), we only listen for the
      // cursor actually leaving the top of the viewport (classic exit
      // intent) plus a plain countdown timer as a fallback. Both listeners
      // are removed as soon as the popup has shown once.
      let shown = false;
      const showPopup = () => {
        if (shown) return;
        shown = true;
        document.documentElement.classList.add("open-drawer", "open-byl"),
          root.style.setProperty(
            "padding-right",
            getScrollBarWidth.init() + "px"
          ),
          e.classList.add("open");
        let s = e.querySelectorAll(".discount");
        null !== s &&
          s.forEach((el) => {
            el.addEventListener("click", (ev) => {
              ev.preventDefault(),
                navigator.clipboard.writeText(el?.dataset.code),
                el.classList.add("action-copy"),
                setTimeout(() => {
                  el.classList.remove("action-copy");
                }, 1500);
            });
          });
        document.removeEventListener("mouseleave", onMouseLeave);
        clearTimeout(fallbackTimer);
      };
      const onMouseLeave = (ev) => {
        if (ev.clientY <= 0) showPopup();
      };
      document.addEventListener("mouseleave", onMouseLeave);
      let fallbackTimer = setTimeout(showPopup, (t ? t : 30) * 1e3);

      let r = document.querySelectorAll(".close-before");
      r.forEach((el) => {
        el.addEventListener("click", () => {
          shown = true;
          clearTimeout(fallbackTimer);
          document.removeEventListener("mouseleave", onMouseLeave);
          document.documentElement.classList.remove(
            "open-drawer",
            "open-byl"
          ),
            root.style.removeProperty("padding-right"),
            e.classList.remove("open");
        });
      });
    }
  }
}
customElements.define("before-you-leave", BeforeYouLeave);
class MiniCartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (e) => {
        e.preventDefault();
        let t = JSON.parse(localStorage.getItem("glozin__wishlist-items")),
          i = this.dataset.productHandle,
          s = t?.indexOf(i);
        if (this.classList.contains("action-add-wishlist")) {
          if (-1 == s || void 0 == s)
            (this.closest(".cart-item").querySelector(
              ".minicart__wishlist"
            ).style.display = "block"),
              (this.closest(".cart-item").querySelector(
                ".minicart__product-info"
              ).style.display = "none");
          else {
            let r = this.closest("cart-notification");
            r.updateQuantity(this.dataset.index, 0);
          }
        } else {
          let a = this.closest("cart-notification");
          a.updateQuantity(this.dataset.index, 0);
        }
      });
  }
}
customElements.define("mini-cart-remove-button", MiniCartRemoveButton);
class MiniCartWishlistAction extends HTMLElement {
  constructor() {
    super(),
      this.actionRemoveWishlist(),
      this.actionAddWishlist(),
      this.actionClose();
  }
  actionRemoveWishlist() {
    this.querySelector(".btn-minicart__remove-js").addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        let t = e.currentTarget;
        this.eventRemove(t);
      }
    );
  }
  actionAddWishlist() {
    this.querySelector(".btn-minicart__add-wishlist-js").addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        let t = e.currentTarget,
          i = localStorage.getItem("glozin__wishlist-items"),
          s = [],
          r = t.dataset.productId;
        if (i) {
          let a = JSON.parse(i);
          a.includes(r) ? s.push(...a) : s.push(...a, r);
        } else s.push(r);
        let o = JSON.stringify(s);
        localStorage.setItem("glozin__wishlist-items", o), this.eventRemove(t);
      }
    );
  }
  eventRemove(e) {
    let t = e.closest("cart-notification");
    t.updateQuantity(e.dataset.index, 0);
  }
  actionClose() {
    document.querySelectorAll(".cart-close-wishlist").forEach((e) => {
      e.addEventListener("click", (e) => {
        let t = e.currentTarget;
        e.preventDefault(),
          (t
            .closest(".cart-item")
            .querySelector(".minicart__wishlist").style.display = "none"),
          (t
            .closest(".cart-item")
            .querySelector(".minicart__product-info").style.display = "block");
      });
    });
  }
}
customElements.define("minicart-wishlist-action", MiniCartWishlistAction);
class CookieBar extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    var e = this;
    getCookie("cookie_bar") || this.classList.remove("hidden"),
      this.querySelectorAll(".cookie-dismiss").forEach((t) => {
        t.addEventListener(
          "click",
          (t) => {
            t.preventDefault();
            let i = t.currentTarget;
            e.remove(),
              "cookie-refuse" == i.id
                ? setCookie("cookie_bar", "dismiss", 7)
                : setCookie("cookie_bar", "dismiss", 30);
          },
          !1
        );
      });
  }
}
customElements.define("cookie-bar", CookieBar);
class TermsConditions extends PopupBase {
  constructor() {
    super(), this.init();
  }
  init() {
    let e = this.querySelector("a");
    e &&
      e.addEventListener("click", (e) => {
        let t = e.currentTarget,
          i = document.querySelector("#popup-terms-conditions");
        if (i) {
          let s = i.getAttribute("data-text");
          this.initPopup(
            i.querySelector(".terms-conditions-content").outerHTML,
            `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${s}</h3>`
          ),
            (t.href = "javascript: (function(){})();"),
            (t.target = "_self");
        }
      });
    let t =
        this.querySelector(".conditions_form_minicart") ||
        this.querySelector(".conditions_form_product"),
      i = document.querySelector(".btn-checkout"),
      s = this.closest("product-form")?.querySelector(".btn-checkout-dynamic");
    t &&
      (getCookie("term_conditions") &&
        (t.setAttribute("checked", ""),
        i && i.removeAttribute("disabled"),
        s && s.classList.remove("disabled")),
      t.addEventListener("change", (e) => {
        i &&
          (e.currentTarget.checked
            ? (i.removeAttribute("disabled"),
              setCookie("term_conditions", 1, 1))
            : (i.setAttribute("disabled", ""),
              deleteCookie("term_conditions"))),
          s &&
            (e.currentTarget.checked
              ? (s.classList.remove("disabled"),
                setCookie("term_conditions", 1, 1))
              : (s.classList.add("disabled"), deleteCookie("term_conditions")));
      }));
  }
}
customElements.define("terms-conditions", TermsConditions);
class QuickView extends PopupBase {
  constructor() {
    super();
  }
  onThisClick() {
    this.classList.add("loading"),
      fetch(this.url)
        .then((e) => e.text())
        .then((e) => {
          let t = parser
            .parseFromString(e, "text/html")
            .querySelector(
              "#shopify-section-product-quickview .product-quickview__content"
            );
          t &&
            (this.loadScripts(t),
            t.classList.remove("hidden"),
            this.initPopup(t));
        })
        .finally(() => {
          Shopify.PaymentButton.init(), this.classList.remove("loading");
        })
        .catch((e) => {
          this.classList.remove("loading"), console.error(e);
        });
  }
  loadScripts(e) {
    let t = e.querySelectorAll("script");
    t.forEach((e) => {
      let t = document.createElement("script");
      (t.src = e.src),
        (t.textContent = e.textContent),
        document.body.appendChild(t).parentNode.removeChild(t);
    });
  }
}
class ButtonQuickView extends QuickView {
  constructor() {
    super(), (this.url = this.dataset.url), this.init();
  }
  init() {
    this.addEventListener("click", this.onThisClick.bind(this));
  }
}
customElements.define("button-quickview", ButtonQuickView);
class ButtonSelectOptions extends QuickView {
  constructor() {
    super(), (this.url = this.dataset.url), this.init();
  }
  init() {
    this.addEventListener("click", this.onThisClick.bind(this));
  }
}
customElements.define("select-option", ButtonSelectOptions);
class ButtonWishlist extends HTMLElement {
  constructor() {
    super(),
      (this.productId = this.dataset.productId),
      (this.action = this.dataset.action || "remove"),
      (this.addTooltip = this.dataset.tooltipAdd || "Add to wishlist"),
      (this.removeTooltip =
        this.dataset.tooltipRemove || "Remove from wishlist"),
      (this.redirectTooltip =
        this.dataset.tooltipRedirect || "Browse wishlist"),
      (this.tooltipDiv = this.querySelector(".tooltip-content")),
      this.init();
  }
  init() {
    this.initializeWishlistStatus(),
      this.addEventListener("click", this.onThisClick.bind(this));
  }
  initializeWishlistStatus() {
    let e = localStorage.getItem("glozin__wishlist-items");
    if (!e) return;
    let t = JSON.parse(e),
      i = t.includes(this.productId);
    i &&
      (this.classList.add("active"),
      this.tooltipDiv &&
        ("remove" === this.action
          ? (this.tooltipDiv.textContent = this.removeTooltip)
          : (this.tooltipDiv.textContent = this.redirectTooltip)));
  }
  actionWhenClicked(e, t) {
    e.forEach((e) => {
      if (!0 === t) {
        e.classList.add("active");
        let i = e.querySelector(".tooltip-content");
        i &&
          ("remove" === this.action
            ? (i.textContent = this.removeTooltip)
            : (i.textContent = this.redirectTooltip));
      } else {
        let s = e.querySelector(".tooltip-content");
        s && (s.textContent = this.addTooltip), e.classList.remove("active");
      }
    });
  }
  onThisClick() {
    let e = localStorage.getItem("glozin__wishlist-items"),
      t = document.querySelectorAll(
        `button-wishlist[data-product-id="${this.productId}"]`
      ),
      i = [];
    if (!this.productId) return;
    if (e && t.length > 0) {
      let s = JSON.parse(e);
      if (s.includes(this.productId)) {
        if (this.action) {
          if ("remove" === this.action) {
            let r = s.indexOf(this.productId);
            if (
              (s.splice(r, 1),
              i.push(...s),
              this.closest(".wishlist-page-main"))
            ) {
              this.closest(".wishlist-list").remove();
              let a = document.querySelectorAll(
                ".wishlist-page-section .product-item__action button-wishlist"
              );
              a.length < 1 &&
                document
                  .querySelector(".wishlist-no-product-js")
                  .classList.remove("hidden");
            } else this.actionWhenClicked(t, !1);
          } else
            i.push(...s),
              (window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/wishlist`);
        } else i.push(...s);
      } else i.push(...s, this.productId), this.actionWhenClicked(t, !0);
    } else i.push(this.productId), this.actionWhenClicked(t, !0);
    let o = JSON.stringify(i);
    localStorage.setItem("glozin__wishlist-items", o), wishlistHeader.init();
  }
}
customElements.define("button-wishlist", ButtonWishlist);
class ButtonCompare extends HTMLElement {
  constructor() {
    super(),
      (this.productId = this.dataset.productId),
      (this.action = this.dataset.action || "remove"),
      (this.addTooltip = this.dataset.tooltipAdd || "Compare"),
      (this.removeTooltip =
        this.dataset.tooltipRemove || "Remove from compare"),
      (this.redirectTooltip = this.dataset.tooltipRedirect || "Browse compare"),
      (this.tooltipDiv = this.querySelector(".tooltip-content")),
      (this.action = this.dataset.action || "remove"),
      this.init();
  }
  init() {
    this.initializeCompareStatus(),
      this.addEventListener("click", this.onThisClick.bind(this));
  }
  initializeCompareStatus() {
    let e = localStorage.getItem("glozin__compare-items");
    if (!e) return;
    let t = JSON.parse(e),
      i = t.includes(this.productId);
    i &&
      (this.classList.add("active"),
      this.tooltipDiv &&
        ("remove" === this.action
          ? (this.tooltipDiv.textContent = this.removeTooltip)
          : (this.tooltipDiv.textContent = this.redirectTooltip)));
  }
  actionWhenClicked(e, t) {
    e.forEach((e) => {
      if (t) {
        e.classList.add("active");
        let i = e.querySelector(".tooltip-content");
        i &&
          ("remove" === this.action
            ? (i.textContent = this.removeTooltip)
            : (i.textContent = this.redirectTooltip));
      } else {
        let s = e.querySelector(".tooltip-content");
        s && (s.textContent = this.addTooltip), e.classList.remove("active");
      }
    });
  }
  onThisClick() {
    let e = localStorage.getItem("glozin__compare-items"),
      t = document.querySelectorAll(
        `button-compare[data-product-id="${this.productId}"]`
      ),
      i = [];
    if (!this.productId) return;
    if (e && t.length > 0) {
      let s = JSON.parse(e);
      if (s.includes(this.productId)) {
        if (this.action) {
          if ("remove" === this.action) {
            let r = s.indexOf(this.productId);
            s.splice(r, 1), i.push(...s), this.actionWhenClicked(t, !1);
          } else
            i.push(...s),
              (window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/compare`);
        } else i.push(...s);
      } else i.push(...s, this.productId), this.actionWhenClicked(t, !0);
    } else i.push(this.productId), this.actionWhenClicked(t, !0);
    let a = JSON.stringify(i);
    localStorage.setItem("glozin__compare-items", a);
  }
}
customElements.define("button-compare", ButtonCompare);
class SwatchFunctions extends SwatchInit {
  constructor() {
    super(), this.init();
  }
  init() {
    this.querySelectorAll(".product__color-swatches--js").forEach((e) => {
      this.checkSwatches(e);
    }),
      this.initAction();
  }
  initAction() {
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange(e) {
    this.productTarget = this.closest(".product__item-js");
    let t = e.target,
      i = JSON.parse(
        this.productTarget.querySelector(".productVariantsQty").textContent
      );
    this.groupFunctionsInit(),
      this.currentVariant
        ? this.groupFunctionsAvailable(i, t)
        : this.groupFunctionsUnavailable(t);
  }
  groupFunctionsInit() {
    this.updateOptions(),
      this.updateMasterId(),
      this.updatePickupAvailability(),
      this.updateVariantStatuses(),
      this.updateMediaSticky();
  }
  groupFunctionsUnavailable(e) {
    this.toggleAddButton(!0, "", !0), this.setUnavailable(e);
  }
  groupFunctionsAvailable(e, t) {
    this.updateURL(),
      this.updateVariantInput(),
      this.updatePrice(this.productTarget),
      this.renderProductInfor(this.productTarget, e, t),
      this.updateShareUrl(),
      this.setAvailable();
  }
  updatePrice(e) {
    if (!this.currentVariant || !e) return;
    let t = document.getElementById(`price-${this.dataset.section}`);
    t && t.classList.remove("visibility-hidden");
    let i = this.currentVariant.compare_at_price,
      s = this.currentVariant.price,
      r = this.currentVariant.unit_price,
      a = this.currentVariant.unit_price_measurement,
      o = Shopify.formatMoney(
        this.currentVariant.price,
        themeGlobalVariables.settings.money_format
      );
    if (r && a) {
      let n = Shopify.formatMoney(
          r,
          themeGlobalVariables.settings.money_format
        ),
        l = 1 != a.reference_value ? a.reference_value : a.reference_unit;
      e.querySelector(".unit-price .number") &&
        (e.querySelector(".unit-price .number").innerHTML = n),
        e.querySelector(".unit-price .unit") &&
          (e.querySelector(".unit-price .unit").innerHTML = l);
    }
    e.querySelector(".price-regular .price") &&
      (e.querySelector(".price-regular .price").innerHTML = o);
    let c = e.querySelector(".product-detail__price .card-product-price");
    if (c) {
      if (!c.querySelector(".compare-price")) {
        var d = document.createElement("div"),
          u = document.createElement("span"),
          h = document.createElement("s");
        h.classList.add("price-item", "compare-price"),
          u.appendChild(h),
          d.appendChild(u),
          d.classList.add("price-regular"),
          e.querySelector(".card-product-price") &&
            e.querySelector(".card-product-price").appendChild(d);
      }
      let p = c.querySelector(".compare-price");
      if (p) {
        if (i && i > s) {
          let m = Shopify.formatMoney(
            i,
            themeGlobalVariables.settings.money_format
          );
          (p.innerHTML = m),
            c.querySelector(".price-regular") &&
              c.querySelector(".price-regular").classList.add("primary-color"),
            c.querySelector(".price-regular .price") &&
              c
                .querySelector(".price-regular .price")
                .classList.add("price--special");
        } else
          (p.innerHTML = ""),
            c.querySelector(".price-regular") &&
              c
                .querySelector(".price-regular")
                .classList.remove("primary-color"),
            c.querySelector(".price-regular .price") &&
              ((c.querySelector(".price-regular .price").innerHTML = o),
              c
                .querySelector(".price-regular .price")
                .classList.remove("price--special"));
        this.currentVariant.available || c.classList.add("price--sold-out");
      }
    }
  }
  toggleAddButton(e = !0, t, i = !0) {
    let s = document.getElementById(`product-form-${this.dataset.section}`);
    if (!s) return;
    let r = s.querySelector('[name="add"]'),
      a = s.querySelector('[name="add"] > span');
    if (
      r &&
      (e
        ? (r.setAttribute("disabled", "disabled"), t && (a.textContent = t))
        : (r.removeAttribute("disabled"),
          (a.textContent = window.variantStrings.addToCart)),
      !i)
    )
      return;
  }
  setUnavailable(e) {
    let t = document.getElementById(`product-form-${this.dataset.section}`),
      i = t.querySelector('[name="add"]'),
      s = t.querySelector('[name="add"] > span'),
      r = document.getElementById(`price-${this.dataset.section}`),
      a = document.getElementById(`Inventory-${this.dataset.section}`),
      o = document.getElementById(`Sku-${this.dataset.section}`),
      n = document.getElementById(`Price-Per-Item-${this.dataset.section}`),
      l = document.getElementById(`Volume-Note-${this.dataset.section}`),
      c = document.getElementById(`Volume-${this.dataset.section}`),
      d = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
    if (e) {
      let u = e.closest("fieldset"),
        h = e.value,
        p = u.querySelector(".option_value");
      p.textContent = h;
    }
    i &&
      ((s.textContent = window.variantStrings.unavailable),
      r && r.classList.add("hidden"),
      a && a.classList.add("hidden"),
      o && o.classList.add("hidden"),
      n && n.classList.add("hidden"),
      l && l.classList.add("hidden"),
      c && c.classList.add("hidden"),
      d && d.classList.add("hidden"));
  }
  setAvailable() {
    let e = document.getElementById(`price-${this.dataset.section}`),
      t = document.getElementById(`Inventory-${this.dataset.section}`),
      i = document.getElementById(`Sku-${this.dataset.section}`),
      s = document.getElementById(`Price-Per-Item-${this.dataset.section}`),
      r = document.getElementById(`Volume-Note-${this.dataset.section}`),
      a = document.getElementById(`Volume-${this.dataset.section}`),
      o = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
    e && e.classList.contains("hidden") && e.classList.remove("hidden"),
      t && t.classList.contains("hidden") && t.classList.remove("hidden"),
      i && i.classList.contains("hidden") && i.classList.remove("hidden"),
      s && s.classList.contains("hidden") && s.classList.remove("hidden"),
      r && r.classList.contains("hidden") && r.classList.remove("hidden"),
      a && a.classList.contains("hidden") && a.classList.remove("hidden"),
      o && o.classList.contains("hidden") && o.classList.remove("hidden");
  }
  updateMedia() {
    if (!this.productTarget) return;
    let e = this.productTarget.querySelector("media-gallery"),
      t = e?.dataset.layout;
    if (t) {
      if ("thumbnail" === t) {
        let i = e.querySelector("slide-with-thumbs");
        if (!i) return;
        let s = i.querySelectorAll(
          ".swiper-wrapper-preview .media-gallery__image.swiper-slide"
        );
        if (0 == s.length || !this.currentVariant?.featured_media) return;
        s.forEach((e, t) => {
          let s = e.getAttribute("data-media-id");
          if (
            s &&
            s ===
              `${this.dataset.section}-${this.currentVariant.featured_media.id}`
          ) {
            let r = e.getAttribute("data-position");
            i.functionGoto(r - 1);
          }
        });
      } else {
        e.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          !0
        );
        let r = document.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        r && r.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }
  updateMediaSticky() {
    if (!this.productTarget || !this.currentVariant) return;
    let e = this.productTarget.querySelector("sticky-add-cart");
    if (!e || !this.currentVariant.featured_media) return;
    let t = e.querySelector("img");
    (t.src = this.currentVariant.featured_media.preview_image.src),
      t.removeAttribute("srcset"),
      t.removeAttribute("sizes");
  }
  renderProductInfor(e, t, i) {
    if (!this.currentVariant || !e) return;
    let s = 0,
      r = 0,
      a = !1,
      o = !1,
      n = !1,
      l = this.currentVariant.available,
      c = this.currentVariant.sku,
      d = this.currentVariant.inventory_management,
      u = this.currentVariant.compare_at_price,
      h = this.currentVariant.price,
      p = e.querySelector(".available-value"),
      m = e.querySelector(".product__sku"),
      y = e.querySelector(".product-detail__variant-picker");
    if (y) {
      let v = y.dataset.type || "swatches",
        g = (t) => {
          let i = e.querySelectorAll(t);
          i.forEach((e, t) => {
            let i = this.currentVariant[`option${t + 1}`];
            i && (e.innerHTML = i);
          });
        };
      if ("swatches" === v) g(".option_value");
      else {
        g(".option_drop_value .option_value"),
          g("swatch-dropdown-select-value .option_value");
        let f = i.closest("swatch-dropdown");
        f && f.classList.contains("active") && f.classList.remove("active");
      }
    }
    m && (m.innerHTML = c || "N/A"),
      t.find((e) => {
        e.id === this.currentVariant.id && (s = e.qty);
      });
    let S = document.querySelector("stock-countdown");
    if (S) {
      let b = S.dataset.itemsLeft,
        L = S.dataset.message;
      if (b >= s && L && s >= 1) {
        S.classList.add("block"), S.classList.remove("hidden");
        let q = S.querySelector("span.count"),
          w = S.querySelector(".progressbar-stock"),
          $;
        ($ = (s / b) * 100 > 100 ? 100 : (s / b) * 100),
          (w.style.width = $ + "%"),
          q && (q.innerHTML = s);
      } else S.classList.remove("block"), S.classList.add("hidden");
    }
    let E = e.querySelector(".product__badges-type-percent");
    u && u > h && ((a = !0), (r = E ? ((u - h) / u) * 100 : u - h)),
      null === d
        ? ((o = !1),
          (n = !1),
          p && (p.innerHTML = window.variantStrings.inStock))
        : l
        ? s < 1
          ? ((n = !0), p && (p.innerHTML = window.variantStrings.preOrder))
          : ((o = !1),
            (n = !1),
            p && (p.innerHTML = window.variantStrings.inStock),
            p && (p.innerHTML = window.variantStrings.inStock))
        : ((o = !0), p && (p.innerHTML = window.variantStrings.outStock)),
      this.renderLabel(a, n, o, r, e),
      this.renderBtnStatus(e, d, l, s);
  }
  renderLabel(e, t, i, s, r) {
    let a = r.querySelector(".product__badges"),
      o = r.querySelector(".sale_badge"),
      n = r.querySelector(".product__badges-sale-scrolling");
    if ((e || t || i) && !a) {
      var l = document.createElement("div");
      l.classList.add(
        "product__badges",
        "fs-small",
        "flex",
        "flex-wrap",
        "gap-5",
        "uppercase"
      ),
        o && o.appendChild(l);
    }
    if (a) {
      let c = a.dataset.saleColor,
        d = a.dataset.soldOutColor,
        u = a.dataset.preOrderColor,
        h = a.dataset.saleBg,
        p = a.dataset.soldOutBg,
        m = a.dataset.preOrderBg,
        y = "true" === a?.dataset.showSale,
        v = "true" === a?.dataset.showPreorder,
        g = "true" === a?.dataset.showSoldOut,
        f = Shopify.formatMoney(s, themeGlobalVariables.settings.money_format),
        S = a.querySelector(".product__badges-sale"),
        b = a.querySelector(".product__badges-sold-out"),
        L = a.querySelector(".product__badges-pre-order"),
        q = a.querySelector(".product__badges-type-price"),
        w = a.querySelector(".product__badges-type-percent");
      if (e && y) {
        if (S)
          q
            ? (S.innerHTML = `${
                window.variantStrings.save ? window.variantStrings.save : "Save"
              } ${f}`)
            : w && (S.innerHTML = -s.toFixed(0) + "%");
        else {
          var $ = document.createElement("div");
          $.classList.add(
            "product__badges-sale",
            "product__badges-inner",
            "py-8",
            "px-15",
            "align-self-start",
            "sale",
            "inline-flex",
            "content-center",
            "subheading_weight",
            "btn-rounded",
            "lh-normal",
            "text-center"
          ),
            $.style.setProperty("--badges-color", c),
            $.style.setProperty("--badges-bg", h),
            ($.innerHTML = `${
              window.variantStrings.save ? window.variantStrings.save : "Save"
            } ${f}`),
            b
              ? a.insertBefore($, b)
              : L
              ? a.insertBefore($, L)
              : a.appendChild($);
        }
      } else S?.remove();
      if (t && v) {
        if (L)
          L.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : "Pre-order";
        else {
          var E = document.createElement("div");
          E.classList.add(
            "product__badges-pre-order",
            "product__badges-inner",
            "py-8",
            "px-15",
            "align-self-start",
            "pre-order",
            "inline-flex",
            "content-center",
            "subheading_weight",
            "btn-rounded",
            "lh-normal",
            "text-center"
          ),
            E.style.setProperty("--badges-color", u),
            E.style.setProperty("--badges-bg", m),
            (E.innerHTML = window.variantStrings.preOrder
              ? window.variantStrings.preOrder
              : "Pre-order"),
            a.appendChild(E);
        }
      } else L?.remove();
      if (i && g) {
        if (b)
          b.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : "Sold out";
        else {
          var k = document.createElement("div");
          k.classList.add(
            "product__badges-sold-out",
            "product__badges-inner",
            "py-8",
            "px-15",
            "align-self-start",
            "sold-out",
            "inline-flex",
            "content-center",
            "subheading_weight",
            "btn-rounded",
            "lh-normal",
            "text-center"
          ),
            k.style.setProperty("--badges-color", d),
            k.style.setProperty("--badges-bg", p),
            (k.innerHTML = window.variantStrings.soldOut
              ? window.variantStrings.soldOut
              : "Sold out"),
            a.appendChild(k);
        }
      } else b?.remove();
    }
    if (n && e) {
      let T = n?.dataset.textProductScrolling,
        C = n.querySelectorAll(".content-badges-scrolling");
      C.forEach((e) => {
        e.innerText = T.replace("[percent_sale]", s.toFixed(0) + "%");
      });
    }
  }
  renderBtnStatus(e, t, i, s) {
    if (e)
      e.querySelectorAll(".product_submit_button").forEach((e) => {
        e.querySelector(".btn-label") &&
          (null === t
            ? ((e.querySelector(".btn-label").innerHTML =
                window.variantStrings.addToCart),
              (e.disabled = !1))
            : i
            ? s < 1
              ? ((e.querySelector(".btn-label").innerHTML =
                  window.variantStrings.preOrder),
                (e.disabled = !1))
              : ((e.querySelector(".btn-label").innerHTML =
                  window.variantStrings.addToCart),
                (e.disabled = !1))
            : ((e.querySelector(".btn-label").innerHTML =
                window.variantStrings.soldOut),
              (e.disabled = !0)));
      });
  }
  updateVariantStatuses() {
    let e = this.variantData.filter(
        (e) => this.querySelector(":checked").value === e.option1
      ),
      t = [...this.querySelectorAll(".product-form__input")];
    t.forEach((i, s) => {
      if (0 === s) return;
      let r = [...i.querySelectorAll('input[type="radio"], option')],
        a = t[s - 1].querySelector(":checked").value,
        o = e
          .filter((e) => e.available && e[`option${s}`] === a)
          .map((e) => e[`option${s + 1}`]);
      this.setInputAvailability(r, o);
    });
  }
  setInputAvailability(e, t) {
    e.forEach((e) => {
      let i = e.getAttribute("value"),
        s = t.includes(i);
      "INPUT" === e.tagName
        ? e.classList.toggle("option-disabled", !s)
        : "OPTION" === e.tagName &&
          (e.innerText = s
            ? i
            : window.variantStrings.unavailable_with_option.replace(
                "[value]",
                i
              ));
    });
  }
  updateOptions() {
    (this.options = []),
      Array.from(this.querySelectorAll("select, fieldset"), (e) => {
        "SELECT" === e.tagName &&
          e.value.split(" / ").forEach((e) => this.options.push(e)),
          "FIELDSET" === e.tagName &&
            this.options.push(
              Array.from(e.querySelectorAll("input")).find((e) => e.checked)
                ?.value
            );
      });
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updateURL() {
    this.currentVariant &&
      "false" !== this.dataset.updateUrl &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    let e = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #sticky-addcart-form-${this.dataset.section}`
    );
    e.forEach((e) => {
      let t = e.querySelector('input[name="id"]');
      (t.value = this.currentVariant.id),
        t.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  updateShareUrl() {
    let e = document.getElementById(`Share-${this.dataset.section}`);
    if (!e || !e.updateUrl) return;
    e.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    let t = e.closest(".share__content");
    if (!t) return;
    let i = t.querySelector(".copy__url");
    i &&
      (i.innerHTML = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updatePickupAvailability() {
    let e = document.querySelector("pickup-availability");
    e &&
      (this.currentVariant && this.currentVariant.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute("available"), (e.innerHTML = "")));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
class SwatchDropdownSelectValue extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", this.activeFilterSort.bind(this), !1);
  }
  activeFilterSort() {
    document.querySelectorAll(".select-custom.active").forEach((e) => {
      e !== this.closest(".select-custom") && e.classList.remove("active");
    }),
      this.closest(".select-custom").classList.contains("active")
        ? this.closest(".select-custom").classList.remove("active")
        : this.closest(".select-custom").classList.add("active");
  }
}
function handleClickOutside(e) {
  e.target.closest(".select-custom") ||
    document.querySelectorAll(".select-custom.active").forEach((e) => {
      e.classList.remove("active");
    });
}
customElements.define(
  "swatch-dropdown-select-value",
  SwatchDropdownSelectValue
),
  document.addEventListener("click", handleClickOutside);
class VariantRadios extends SwatchFunctions {
  constructor() {
    super();
  }
  init() {
    this.querySelectorAll(".product__color-swatches--js").forEach((e) => {
      this.checkSwatches(e),
        this.variantHover(e),
        e.addEventListener("click", this.onVariantChange.bind(this), !1);
    });
  }
  variantHover(e) {
    let t = e.closest(".product-item");
    if (!t) return;
    let i = e.closest(".swiper");
    if (!i) return;
    let s = () => {
        i.classList.remove("show-tooltip");
      },
      r = () => {
        i.classList.add("show-tooltip");
      };
    e.addEventListener("mouseout", s, !1),
      e.addEventListener("mouseover", r, !1),
      e.addEventListener("mouseenter", r, !1),
      e.addEventListener("mouseleave", s, !1);
  }
  onVariantChange(e) {
    e.preventDefault();
    let t = e.currentTarget;
    (this.productTarget = this.closest(".product__item-js")),
      (this.position_swatch = t.dataset.position);
    let i = JSON.parse(
      this.productTarget.querySelector(".productItemVariantsQty").textContent
    );
    if (!t.classList.contains("active")) {
      let s = t
        .closest(".product__color-swatches")
        .querySelectorAll(".product__color-swatches--js");
      s.forEach((e) => {
        e.classList.remove("active");
      }),
        t.classList.toggle("active"),
        this.groupFunctionsInit(this.getVariantData()),
        this.currentVariant && this.groupFunctionsAvailable(i);
    }
  }
  groupFunctionsInit(e) {
    this.updateOptions(), this.updateMasterId(e);
  }
  groupFunctionsAvailable(e) {
    this.updatePrice(), this.updateMedia(), this.renderProductInfor(e);
  }
  updatePrice() {
    if (!this.currentVariant || !this.productTarget) return;
    let e = document.getElementById(`price-${this.dataset.section}`);
    e && e.classList.remove("visibility-hidden");
    let t = this.currentVariant.compare_at_price,
      i = this.currentVariant.price,
      s = this.currentVariant.unit_price,
      r = this.currentVariant.unit_price_measurement,
      a = Shopify.formatMoney(
        this.currentVariant.price,
        themeGlobalVariables.settings.money_format
      );
    if (s && r) {
      let o = Shopify.formatMoney(
          s,
          themeGlobalVariables.settings.money_format
        ),
        n = 1 != r.reference_value ? r.reference_value : r.reference_unit;
      this.productTarget.querySelector(".unit-price .number") &&
        (this.productTarget.querySelector(".unit-price .number").innerHTML = o),
        this.productTarget.querySelector(".unit-price .unit") &&
          (this.productTarget.querySelector(".unit-price .unit").innerHTML = n);
    }
    this.productTarget.querySelector(".price-regular .price") &&
      (this.productTarget.querySelector(".price-regular .price").innerHTML = a);
    let l = this.productTarget.querySelector(".card-product-price");
    if (l) {
      if (!l.querySelector(".compare-price")) {
        var c = document.createElement("div"),
          d = document.createElement("span"),
          u = document.createElement("s");
        u.classList.add("price-item", "dark-gray", "compare-price"),
          d.appendChild(u),
          c.appendChild(d),
          c.classList.add("price-sale"),
          this.productTarget.querySelector(".card-product-price") &&
            this.productTarget
              .querySelector(".card-product-price")
              .appendChild(c);
      }
      let h = l.querySelector(".compare-price");
      if (h) {
        if (t && t > i) {
          let p = Shopify.formatMoney(
            t,
            themeGlobalVariables.settings.money_format
          );
          (h.innerHTML = p),
            l.querySelector(".price-regular") &&
              l.querySelector(".price-regular").classList.add("primary-color"),
            l.querySelector(".price-regular .price") &&
              l
                .querySelector(".price-regular .price")
                .classList.add("price--special");
        } else
          (h.innerHTML = ""),
            l.querySelector(".price-regular") &&
              l
                .querySelector(".price-regular")
                .classList.remove("primary-color"),
            l.querySelector(".price-regular .price") &&
              (l
                .querySelector(".price-regular .price")
                .classList.remove("price--special"),
              (l.querySelector(".price-regular .price").innerHTML = a));
        this.currentVariant.available || l.classList.add("price--sold-out");
      }
    }
  }
  renderProductInfor(e) {
    if (!this.currentVariant || !this.productTarget) return;
    let t = 0,
      i = 0,
      s = !1,
      r = !1,
      a = !1,
      o = !1,
      n = !1,
      l = this.currentVariant.compare_at_price,
      c = this.currentVariant.price,
      d = this.productTarget,
      u = d.querySelector(".product__badges-sale-scrolling"),
      h = d.querySelector(".product__badges-type-percent"),
      p = e.reduce((e, t) => {
        let i = e.find((e) => e.option === t.option);
        return (
          i
            ? ((i.qty += t.qty),
              !0 === t.available && (i.available = !0),
              "" === t.mamagement && (i.mamagement = ""))
            : e.push(t),
          e
        );
      }, []);
    p.find((e) => {
      e.option === this.currentVariant.option1 &&
        ((t = e.qty), (o = e.available), (n = e.mamagement));
    }),
      l && l > c && ((s = !0), (i = u || h ? ((l - c) / l) * 100 : l - c)),
      "" === n ? ((r = !1), (a = !1)) : o && t < 1 ? (a = !0) : o || (r = !0),
      this.renderLabel(s, a, r, i, this.productTarget);
  }
  updateMasterId(e) {
    return (this.currentVariant = e.find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    ));
  }
  updateOptions() {
    (this.options = Array.from(
      this.productTarget.querySelectorAll(
        ".product__color-swatches--js.active"
      ),
      (e) => e.getAttribute("data-value")
    )),
      this.variantData.find((e) => {
        if (1 == this.options.length) {
          let t = { 1: e.option1, 2: e.option2, 3: e.option3 };
          t[this.position_swatch] === this.options[0] &&
            (this.options = e.options);
        }
      });
  }
  updateMedia() {
    if (this.currentVariant) {
      if (
        !this.productTarget
          .querySelector(".product__media img")
          .classList.contains("hidden")
      ) {
        let e = this.productTarget
          .querySelector(".product__media img")
          .closest(".product-item");
        (e.querySelector("video") || e.querySelector("iframe")) &&
          (this.productTarget
            .querySelector(".product__media img")
            .classList.add("hidden"),
          e.querySelector("video")?.classList.remove("hidden"),
          e.querySelector("iframe")?.classList.remove("hidden"));
      }
      if (
        this.currentVariant.featured_media &&
        (this.productTarget.querySelector(".product__media img") &&
          this.productTarget
            .querySelector(".product__media img")
            .removeAttribute("srcset"),
        this.productTarget.querySelector(".product__media img") &&
          this.productTarget
            .querySelector(".product__media img")
            .setAttribute(
              "src",
              this.currentVariant.featured_media.preview_image.src
            ),
        this.productTarget
          .querySelector(".product__media img")
          .classList.contains("hidden"))
      ) {
        this.productTarget
          .querySelector(".product__media img")
          .classList.remove("hidden");
        let t = this.productTarget
          .querySelector(".product__media img")
          .closest(".product-item");
        (t.querySelector("video") || t.querySelector("iframe")) &&
          (t.querySelector("video")?.classList.add("hidden"),
          t.querySelector("iframe")?.classList.add("hidden"));
      }
    }
  }
}
customElements.define("variant-radios", VariantRadios);
class VariantRadiosDetail extends SwatchFunctions {
  constructor() {
    super();
  }
  groupFunctionsAvailable(e, t) {
    this.updateURL(),
      this.updateVariantInput(),
      this.updatePrice(this.productTarget),
      this.renderProductInfor(this.productTarget, e, t),
      this.updateMedia(),
      this.updateShareUrl(),
      this.mapStickyDropdown(),
      this.setAvailable();
  }
  mapStickyDropdown() {
    if (!this.currentVariant || !this.productTarget) return;
    let e = this.productTarget.querySelector("sticky-add-cart");
    if (!e) return;
    let t = e.querySelector("select"),
      i = this.productTarget.querySelector(
        "variant-radios-detail, variant-group-detail"
      );
    if (t || !i) {
      for (let s = 0; s < t.options.length; s++)
        if (t.options[s].value === this.currentVariant.title) {
          (t.options[s].selected = !0),
            i.querySelectorAll("fieldset").forEach((e, t) => {
              e.querySelectorAll("input").forEach((e) => {
                e.removeAttribute("checked"),
                  e.value === this.currentVariant[`option${t + 1}`] &&
                    (e.checked = !0);
              });
            });
          break;
        }
    }
  }
}
customElements.define("variant-radios-detail", VariantRadiosDetail);
class VariantRadiosSingle extends SwatchFunctions {
  constructor() {
    super();
  }
  groupFunctionsAvailable(e) {
    this.updateVariantInput(),
      this.updatePrice(this.productTarget),
      this.renderProductInfor(this.productTarget, e),
      this.updateMedia();
  }
}
customElements.define("variant-radios-single", VariantRadiosSingle);
class VariantGroupDetail extends VariantRadiosDetail {
  constructor() {
    super();
  }
  onVariantChange(e) {
    this.productTarget = this.closest(".product__item-js");
    let t = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent
    );
    this.groupFunctionsInit(),
      this.currentVariant
        ? (this.checkColorGroup(e),
          this.updateURL(),
          this.updateVariantInput(),
          this.updatePrice(this.productTarget),
          this.renderProductInfor(this.productTarget, t, e.target),
          this.updateShareUrl(),
          this.mapStickyDropdown(),
          this.setAvailable())
        : (this.groupFunctionsUnavailable(e.target), this.checkColorGroup(e));
  }
  checkColorGroup(e) {
    let t = this.productTarget.dataset.colorTrigger;
    if (t) {
      let i = t.split(","),
        s = this.productTarget.querySelector(
          `[data-value="${CSS.escape(e.target.value)}"]`
        ),
        r = s?.dataset.name,
        a = i.includes(r || e.target.name);
      if (a) {
        let o = s?.dataset.colorValue;
        this.updateMediaGroup(o || e.target.value);
      } else this.updateMedia();
    }
  }
  updateMediaGroup(e) {
    let t = this.dataset.productHandle,
      i = this.productTarget.dataset.desktopLayout,
      s = this.productTarget.dataset.mobileLayout,
      r = this.productTarget.dataset.zoom,
      a = this.productTarget.dataset.section,
      o = this.productTarget.querySelector("zoom-action"),
      n = this.productTarget.dataset.typeElement;
    t &&
      a &&
      i &&
      ("grid_1_column" !== i && "grid_2_column" !== i && "stack" !== i
        ? fetch(`/products/${t}?section_id=media-gallery-slide`)
            .then((e) => e.text())
            .then((t) => {
              let l = parser.parseFromString(t, "text/html");
              if (!l) return;
              let c = l.querySelector("slide-with-thumbs");
              c.classList.add(i),
                "thumbnail_left" === i &&
                  c.classList.add(
                    "flex-md",
                    "gap-10",
                    "overflow-hidden",
                    "justify-content-right"
                  ),
                (c.dataset.thumbDirection =
                  "thumbnail_left" === i ? "vertical" : "horizontal");
              let d = c.querySelector(".media-main-swiper .swiper-wrapper"),
                u = this.productTarget.querySelector("slide-with-thumbs"),
                h = u.querySelector(".media-main-swiper .swiper-wrapper");
              if ("no_zoom" === r) {
                let p = l.querySelectorAll(
                  "div.media-gallery__image[data-pane-container]"
                );
                p.forEach((t) => {
                  if (
                    (t.dataset.alt && t.dataset.alt == e) ||
                    !this.getAllButtonValue().includes(t.dataset.alt)
                  ) {
                    let i = t.dataset.media;
                    i && t.setAttribute("data-media-id", `${a}-${i}`),
                      (d.innerHTML += t.outerHTML);
                  }
                  n && ((h.innerHTML = d.innerHTML), u.updateSlide());
                });
              } else if ("open_lightbox" !== r) {
                let m = l.querySelectorAll(
                  "div.media-gallery__image[data-pane-container]"
                );
                m.forEach((t) => {
                  if (
                    (t.dataset.alt && t.dataset.alt == e) ||
                    !this.getAllButtonValue().includes(t.dataset.alt)
                  ) {
                    let i = t.dataset.media;
                    i && t.setAttribute("data-media-id", `${a}-${i}`),
                      (c.querySelector(".swiper-wrapper").innerHTML +=
                        t.outerHTML);
                  }
                });
              } else {
                let y = l.querySelectorAll("a.media-gallery__image");
                y.forEach((t) => {
                  if (
                    (t.dataset.alt && t.dataset.alt == e) ||
                    !this.getAllButtonValue().includes(t.dataset.alt)
                  ) {
                    let i = t.dataset.media;
                    i && t.setAttribute("data-media-id", `${a}-${i}`),
                      (d.innerHTML += t.outerHTML);
                  }
                });
              }
              if ("hidden_thumbnail" !== i) {
                let v = l.querySelector(
                    ".media-gallery__append .media-thumb-swiper"
                  ),
                  g = v.querySelector(".swiper-wrapper"),
                  f = u.querySelector(".media-thumb-swiper .swiper-wrapper");
                if (!v || !f) return;
                "show_thumbnails" !== s &&
                  (v
                    .querySelector(".thumbnail-slide")
                    .classList.add("thumbnail-slide__mobile--hidden"),
                  (c.innerHTML +=
                    l.querySelector(".swiper-pagination").outerHTML)),
                  "thumbnail_bottom" === i &&
                    (v
                      .querySelector(".thumbnail-slide")
                      .classList.add("mt-10", "thumb-bottom"),
                    v
                      .querySelector(".thumbnail-slide")
                      .setAttribute("style", "--gap: 15px")),
                  "thumbnail_left" === i &&
                    (v.classList.add("mt-10"),
                    v
                      .querySelector(".thumbnail-slide")
                      ?.classList.contains("swiper-horizontal") &&
                      (v
                        .querySelector(".thumbnail-slide")
                        ?.classList.remove("swiper-horizontal"),
                      v
                        .querySelector(".thumbnail-slide")
                        ?.classList.add("swiper-vertical")));
                let S = l.querySelectorAll(
                  "div.media-gallery__image:not([data-pane-container])"
                );
                S.forEach((t) => {
                  if (
                    (t.dataset.alt && t.dataset.alt == e) ||
                    !this.getAllButtonValue().includes(t.dataset.alt)
                  ) {
                    let i = t.dataset.media;
                    i && t.setAttribute("data-media-id", `${a}-${i}`),
                      (g.innerHTML += t.outerHTML);
                  }
                }),
                  (c.innerHTML += v.outerHTML),
                  n && ((f.innerHTML = g.innerHTML), u.updateThumbSlide());
              } else
                c.innerHTML += l.querySelector(".swiper-pagination").outerHTML;
              o && ((o.innerHTML = c.outerHTML), (o.drift = null));
            })
            .finally(() => {
              this.updateMedia(),
                o &&
                  ("open_lightbox" !== r && "no_zoom" !== r && o.initDrift(),
                  "open_lightbox" === r && "no_zoom" !== r && o.initLightBox());
            })
            .catch((e) => {
              console.error(e);
            })
        : fetch(`/products/${t}?section_id=media-gallery-grid`)
            .then((e) => e.text())
            .then((t) => {
              let s = parser.parseFromString(t, "text/html");
              if (!s) return;
              let l = document.createElement("div");
              if (
                ("stack" === i && l.classList.add("stacked", "grid", "gap-10"),
                ("grid_1_column" === i || "grid_2_column" === i) &&
                  l.classList.add("grid-cols", "grid", "gap"),
                ("stack" === i ||
                  "grid_1_column" === i ||
                  "grid_2_column" === i) &&
                  (l.id = `GalleryViewer-${a}`),
                "grid_1_column" === i &&
                  l.setAttribute(
                    "style",
                    "--col-number: 1;--col-desktop: 1;--col-tablet: 1;--col-gap: 10px;"
                  ),
                "grid_2_column" === i &&
                  l.setAttribute(
                    "style",
                    "--col-number: 2;--col-tablet: 2;--col-gap: 10px;"
                  ),
                "no_zoom" === r)
              ) {
                let c = s.querySelectorAll(
                  "div.media-gallery__image:not([data-pane-container])"
                );
                if (
                  (c.forEach((t) => {
                    if (
                      (t.dataset.alt && t.dataset.alt == e) ||
                      !this.getAllButtonValue().includes(t.dataset.alt)
                    ) {
                      let i = t.dataset.media;
                      i && t.setAttribute("data-media-id", `${a}-${i}`),
                        (l.innerHTML += t.outerHTML);
                    }
                  }),
                  n)
                ) {
                  let d = this.productTarget.querySelector(
                    `#GalleryViewer-${a}`
                  );
                  d.innerHTML = l.innerHTML;
                }
              } else if ("open_lightbox" !== r) {
                let u = s.querySelectorAll(
                  "div.media-gallery__image[data-pane-container]"
                );
                u.forEach((t) => {
                  if (
                    (t.dataset.alt && t.dataset.alt == e) ||
                    !this.getAllButtonValue().includes(t.dataset.alt)
                  ) {
                    let i = t.dataset.media;
                    i && t.setAttribute("data-media-id", `${a}-${i}`),
                      (l.innerHTML += t.outerHTML);
                  }
                });
              } else {
                let h = s.querySelectorAll("a.media-gallery__image");
                h.forEach((t) => {
                  if (
                    (t.dataset.alt && t.dataset.alt == e) ||
                    !this.getAllButtonValue().includes(t.dataset.alt)
                  ) {
                    let i = t.dataset.media;
                    i && t.setAttribute("data-media-id", `${a}-${i}`),
                      (l.innerHTML += t.outerHTML);
                  }
                });
              }
              o && ((o.innerHTML = l.outerHTML), (o.drift = null));
            })
            .finally(() => {
              this.updateMedia(),
                o &&
                  ("open_lightbox" !== r && "no_zoom" !== r && o.initDrift(),
                  "open_lightbox" === r && "no_zoom" !== r && o.initLightBox());
            })
            .catch((e) => {
              console.error(e);
            }));
  }
  getAllButtonValue() {
    let e = [];
    return (
      this.querySelectorAll(
        ".product__color-swatches--js, .product-sticky-js"
      ).forEach((t) => {
        t.classList.contains("product__color-swatches--js") && t.dataset.value
          ? e.push(t.dataset.value)
          : t.classList.contains("product-sticky-js") &&
            t.dataset.colorValue &&
            e.push(t.dataset.colorValue);
      }),
      e
    );
  }
}
customElements.define("variant-group-detail", VariantGroupDetail);
class VariantRadiosSticky extends VariantRadiosDetail {
  constructor() {
    super();
  }
}
customElements.define("variant-radios-sticky", VariantRadiosSticky);
class VariantGroupSticky extends VariantGroupDetail {
  constructor() {
    super();
  }
}
customElements.define("variant-group-sticky", VariantGroupSticky);
class CountdownTimer extends HTMLElement {
  constructor() {
    super(),
      (this.timeoutMessage = this.dataset.timeoutMessage),
      (this.format = this.dataset.format || "dd:hh:mm:ss"),
      (this.interval = null),
      this.init();
  }
  init() {
    let e = this.dataset?.endtime,
      t = this.dataset.minutesLeft,
      i = this.querySelector(".countdown-inner");
    if (
      (i
        ? (i.innerHTML = this.appendChildHtml(t).innerHTML)
        : (this.innerHTML = this.appendChildHtml(t).innerHTML),
      e)
    ) {
      let s = "";
      if (this.isISODate(e)) (s = e), this.mainFunction(s, t);
      else if (this.isValidDate(e)) {
        let r = e.split("-");
        (s =
          r[2] +
          "-" +
          r[0].padStart(2, "0") +
          "-" +
          r[1].padStart(2, "0") +
          "T00:00:00Z"),
          this.mainFunction(s, t);
      } else this.mainFunction(s, t);
    } else this.mainFunction("", t);
  }
  mainFunction(e, t) {
    let i = {},
      s = (e) => {
        let t = {};
        return (
          this.format.includes("dd") && (t.days_timer = Math.floor(e / 864e5)),
this.format.includes("hh") &&
  (t.hours_timer = Math.floor((e / 36e5) % 24)),
          this.format.includes("mm") &&
            ("mm:ss" === this.format
              ? (t.minutes_timer = Math.floor(e / 1e3 / 60))
              : (t.minutes_timer = Math.floor((e / 1e3 / 60) % 60))),
          this.format.includes("ss") &&
            (t.seconds_timer = Math.floor((e / 1e3) % 60)),
          t
        );
      };
    if (Date.parse(e) || t) {
      let r = new Date(e);
      t && (r = new Date(Date.now() + 6e4 * parseInt(t)));
      let a = () => {
        let e = new Date(),
          t = r - e;
        (i = t > 0 ? s(t) : s(0)).days_timer > 0 ||
        i.hours_timer > 0 ||
        i.minutes_timer > 0 ||
        i.seconds_timer > 0 ||
        !this.timeoutMessage
          ? Object.entries(i).forEach(([e, t]) => {
              this.querySelector("." + e) &&
                (this.querySelector("." + e).innerHTML = t
                  .toString()
                  .padStart(2, "0"));
            })
          : (this.timeoutMessage && (this.innerHTML = this.timeoutMessage),
            clearInterval(this.interval)),
          this.classList.remove("hidden");
        let a = this.closest(".product__badges-sale-countdown");
        a && (a.classList.remove("hidden"), a.classList.add("inline-flex"));
      };
      (this.interval = setInterval(a, 1e3)), a();
    } else
      Object.entries((i = s(0))).forEach(([e, t]) => {
        this.querySelector("." + e) &&
          (this.querySelector("." + e).innerHTML = t
            .toString()
            .padStart(2, "0"));
      });
  }
  appendChildHtml(e) {
    let t = this.dataset?.days,
      i = this.dataset?.hours,
      s = this.dataset?.mins,
      r = this.dataset?.secs,
      a = document.createElement("div");
    return (
      (a.innerHTML = `${
        e
          ? ""
          : `${
              this.format.includes("dd")
                ? `<div class="countdown--container"><span class="days_timer count-timer"></span><span class="timer_announcementbar--text"> ${
                    t || ""
                  }</span></div>`
                : ""
            }${
              this.format.includes("hh")
                ? `<div class="countdown--container"><span class="hours_timer count-timer"></span><span class="timer_announcementbar--text"> ${
                    i || ""
                  }</span></div>`
                : ""
            }`
      }<div class="countdown--container"><span class="minutes_timer count-timer"></span><span class="timer_announcementbar--text"> ${
        e ? "m" : s || ""
      }</span></div><div class="countdown--container"><span class="seconds_timer count-timer"></span><span class="timer_announcementbar--text"> ${
        e ? "s" : r || ""
      }</span></div>`),
      a
    );
  }
  isISODate(e) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/.test(e);
  }
  isValidDate(e) {
    return !!/^\d{2}-\d{2}-\d{4}$/.test(e);
  }
}
customElements.define("countdown-timer", CountdownTimer),
  customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class e extends PopupBase {
        constructor() {
          super(),
            (this.form = this.querySelector("form")),
            (this.form.querySelector("[name=id]").disabled = !1),
            this.form.addEventListener(
              "submit",
              this.onSubmitHandler.bind(this)
            ),
            (this.cart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            (this.hideErrors = "true" === this.dataset.hideErrors),
            (this.productItem =
              this.form.closest(".product-item") ||
              this.form.closest("sticky-add-cart"));
        }
        onSubmitHandler(e) {
          if (
            (e.preventDefault(),
            "true" === this.submitButton.getAttribute("aria-disabled"))
          )
            return;
          this.handleErrorMessage(),
            this.submitButton.setAttribute("aria-disabled", !0);
          let t = document.querySelector(".cart-recommend");
          t && t.classList.contains("open") && t.classList.remove("open"),
            this.submitButton.classList.add("loading");
          let i = fetchConfig("javascript");
          (i.headers["X-Requested-With"] = "XMLHttpRequest"),
            delete i.headers["Content-Type"];
          let s = new FormData(this.form),
            r = this.form.closest(".product-detail__information");
          r &&
            r.querySelectorAll("product-property input").forEach((e) => {
              e.classList.contains("file") && e.files[0]
                ? s.append(e.name, e.files[0])
                : e.classList.contains("text") &&
                  e.value &&
                  s.append(e.name, e.value);
            }),
            this.cart &&
              (s.append(
                "sections",
                this.cart.getSectionsToRender().map((e) => e.id)
              ),
              s.append("sections_url", window.location.pathname),
              this.cart.setActiveElement(document.activeElement));
          let a = document.body.classList.contains("template-cart");
          a &&
            s.append(
              "sections",
              this.getMainCartSectionRender().map((e) => e.id)
            ),
            (i.body = s),
            fetch(`${routes.cart_add_url}`, i)
              .then((e) => e.json())
              .then((e) => {
                if (e.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: s.get("id"),
                    errors: e.errors || e.description,
                    message: e.message,
                  }),
                    this.handleErrorMessage(e.description),
                    this.productItem &&
                      this.handleErrorMessagePopup(e.description);
                  return;
                }
                if (e.sections) {
                  if (!e.id && !e.items) {
                    this.handleErrorMessagePopup(window.cartStrings.error);
                    return;
                  }
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
                fetch("/cart.json")
                  .then((e) => e.json())
                  .then((e) => {
                    if (void 0 != e.item_count) {
                      document.querySelectorAll(".cart-count").forEach((t) => {
                        t.classList.contains("cart-count-drawer")
                          ? (t.innerHTML = `(${e.item_count})`)
                          : (t.innerHTML =
                              e.item_count > 100 ? "~" : e.item_count);
                      }),
                        document.querySelector("header-total-price") &&
                          document
                            .querySelector("header-total-price")
                            .updateTotal(e);
                      let t = document.querySelector("free-ship-progress-bar");
                      t && t.init(e.items_subtotal_price);
                    }
                  })
                  .catch((e) => {
                    throw e;
                  }),
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: s.get("id"),
                    cartData: e,
                  });
                let t = document.querySelector(
                    ".tingle-modal--visible.tingle-modal.quickview"
                  ),
                  i = document.querySelector(
                    ".tingle-modal--visible.tingle-modal.shopable-video"
                  );
                (t || i) &&
                  (document.documentElement
                    .querySelector("body")
                    .classList.contains("tingle-enabled") &&
                    document.documentElement
                      .querySelector("body")
                      .classList.remove("tingle-enabled"),
                  i && i.remove(),
                  t && t.remove());
                let r = document.body.classList.contains("template-cart");
                if (r) {
                  if (!e.errors) {
                    this.getMainCartSectionRender().forEach((t) => {
                      if (void 0 != t.selector) {
                        let i =
                          document
                            .getElementById(t.id)
                            .querySelector(t.selector) ||
                          document.getElementById(t.id);
                        i.innerHTML = this.getSectionInnerHTML(
                          e.sections[t.id],
                          t.selector
                        );
                      }
                    });
                    let a = this.getSectionInnerHTML(
                        e.sections["main-cart-items"],
                        ".cart-info .totals"
                      ),
                      o = document.querySelector(".cart-info .totals");
                    a && o && (o.innerHTML = a);
                  }
                } else
                  e.errors ||
                    (this.cart.getSectionsToRender().forEach((t) => {
                      let i = document.getElementById(t.id),
                        s = new DOMParser().parseFromString(
                          e.sections[t.id],
                          "text/html"
                        );
                      i &&
                        (i.innerHTML =
                          s.querySelector("#minicart-form").innerHTML);
                    }),
                    this.cart.cartAction(),
                    this.cart &&
                      this.cart.classList.contains("is-empty") &&
                      this.cart.classList.remove("is-empty"),
                    this.cart.open());
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove("loading"),
                  this.cart &&
                    this.cart.classList.contains("is-empty") &&
                    this.cart.classList.remove("is-empty"),
                  this.submitButton.removeAttribute("aria-disabled");
                let e = document.querySelector(".cart-recommend");
                if (e && !e.classList.contains("hidden-recommend")) {
                  if (e.classList.contains("cart-recommend-custom")) {
                    let t = document.querySelectorAll(".cart-upsell-item"),
                      i = document.querySelectorAll(
                        ".swiper-cart-upsell .swiper-slide"
                      );
                    t.length > 0
                      ? setTimeout(function () {
                          e.classList.add("open");
                        }, 800)
                      : 0 === i.length &&
                        (e.classList.remove("block"),
                        e.classList.add("hidden"));
                  } else
                    setTimeout(function () {
                      e.classList.add("open");
                    }, 800);
                }
              });
        }
        getMainCartSectionRender() {
          return [
            {
              id: "main-cart-items",
              section: document.getElementById("main-cart-items")?.dataset.id,
              selector: ".js-contents",
            },
          ];
        }
        getSectionInnerHTML(e, t) {
          return new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(t).innerHTML;
        }
        handleErrorMessage(e = !1) {
          !this.hideErrors &&
            ((this.errorMessageWrapper =
              this.errorMessageWrapper ||
              this.querySelector(".product-form__error-message-wrapper")),
            this.errorMessageWrapper &&
              ((this.errorMessage =
                this.errorMessage ||
                this.errorMessageWrapper.querySelector(
                  ".product-form__error-message"
                )),
              this.errorMessageWrapper.toggleAttribute("hidden", !e),
              e && (this.errorMessage.textContent = e)));
        }
        handleErrorMessagePopup(e = !1) {
          let t = `${window.location.pathname}?section_id=form-message`;
          fetch(t)
            .then((e) => e.text())
            .then((t) => {
              let i = new DOMParser().parseFromString(t, "text/html"),
                s = i.querySelector(".product-form__error-message-wrapper"),
                r = s.querySelector(".product-form__error-message");
              (r.textContent = e), showToast(s.innerHTML, 5e3, "modal-error");
            })
            .catch((e) => {
              throw e;
            });
        }
      }
    );
class VariantRadiosQuickEdit extends SwatchInit {
  constructor() {
    super(), this.init();
  }
  init() {
    this.querySelectorAll(".product__color-swatches--js").forEach((e) => {
      this.checkSwatches(e);
    }),
      this.querySelectorAll(".option-swatch-js").forEach((e) =>
        e.addEventListener("click", this.onVariantChange.bind(this), !1)
      );
  }
  onVariantChange(e) {
    e.preventDefault();
    let t = e.currentTarget,
      i = t.getAttribute("data-value");
    for (var s of t.closest("fieldset").querySelectorAll(".option-swatch-js"))
      s.classList.remove("active");
    t.classList.toggle("active"),
      (t
        .closest("fieldset")
        .querySelector(".swatch-selected-value").textContent = i),
      (this.options = Array.from(
        this.querySelectorAll(".option-swatch-js.active"),
        (e) => e.getAttribute("data-value")
      )),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updateVariantStatuses(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateVariantInput(),
          this.renderProductInfo())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    let e = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    e.querySelector(".product__media img") &&
      (e.querySelector(".product__media img").removeAttribute("srcset"),
      e
        .querySelector(".product__media img")
        .setAttribute(
          "src",
          this.currentVariant.featured_media.preview_image.src
        ));
  }
  updateVariantInput() {
    let e = document.querySelectorAll(
      `#product-form-quick-edit-${this.dataset.section}`
    );
    e.forEach((e) => {
      let t = e.querySelector('input[name="id"]');
      (t.value = this.currentVariant.id),
        t.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  renderProductInfo() {
    if (!this.currentVariant) return;
    let e = this.currentVariant.compare_at_price,
      t = this.currentVariant.price,
      i = Shopify.formatMoney(
        this.currentVariant.price,
        cartStrings?.money_format
      ),
      s = document.getElementById(
        `product-form-quick-edit-${this.dataset.section}`
      );
    s.querySelector(".price-regular .price").innerHTML = i;
    let r = s.querySelector(".price");
    if (
      (r.classList.remove("price--sold-out", "price--on-sale"),
      r
        .querySelector(".price-regular .price")
        .classList.remove("special-price"),
      e && e > t)
    ) {
      let a = Shopify.formatMoney(e, cartStrings?.money_format);
      if (!r.querySelector(".compare-price")) {
        var o = r.querySelector(".price__sale"),
          n = document.createElement("span"),
          l = document.createElement("s");
        l.classList.add("price-item", "compare-price"),
          n.appendChild(l),
          o && o.appendChild(n);
      }
      r.querySelector(".compare-price") &&
        (r.querySelector(".compare-price").innerHTML = a),
        r.classList.add("price--on-sale"),
        r.querySelector(".price-regular .price").classList.add("special-price");
    } else this.currentVariant.available || r.classList.add("price--sold-out");
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings?.soldOut
    );
  }
  toggleAddButton(e = !0, t, i = !0) {
    let s = document.getElementById(
      `product-form-quick-edit-${this.dataset.section}`
    );
    if (!s) return;
    let r = s.querySelector('[name="add"]'),
      a = s.querySelector('[name="add"] > span');
    if (
      (s.querySelector(".product-dynamic-checkout"),
      r &&
        (e
          ? (r.setAttribute("disabled", "disabled"), t && (a.textContent = t))
          : (r.removeAttribute("disabled"),
            (a.textContent = window.variantStrings?.addToCart)),
        !i))
    )
      return;
  }
  setUnavailable() {
    let e = document.getElementById(
        `product-form-quick-edit-${this.dataset.section}`
      ),
      t = e.querySelector('[name="add"]'),
      i = e.querySelector('[name="add"] > span'),
      s = document.getElementById(`price-${this.dataset.section}`);
    t &&
      ((i.textContent = window.variantStrings?.unavailable),
      s && s.classList.add("visibility-hidden"));
  }
  setAvailability(e, t) {
    e.forEach((e) => {
      t.includes(e.dataset.value)
        ? e.classList.remove("option-disabled")
        : e.classList.add("option-disabled");
    });
  }
  updateVariantStatuses() {
    let e = this.getVariantData().filter(
        (e) => this.querySelector(".active").dataset.value === e.option1
      ),
      t = [...this.querySelectorAll(".product-form__input")];
    t.forEach((i, s) => {
      if (0 === s) return;
      let r = [...i.querySelectorAll(".option-swatch-js")],
        a = t[s - 1].querySelector(".active").dataset.value,
        o = e
          .filter((e) => e.available && e[`option${s}`] === a)
          .map((e) => e[`option${s + 1}`]);
      this.setAvailability(r, o);
    });
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-radios-quick-edit", VariantRadiosQuickEdit),
  customElements.get("product-form-quick-edit") ||
    customElements.define(
      "product-form-quick-edit",
      class e extends HTMLElement {
        constructor() {
          super(),
            (this.form = this.querySelector("form")),
            (this.form.querySelector("[name=id]").disabled = !1),
            this.form.addEventListener(
              "submit",
              this.onSubmitHandler.bind(this)
            ),
            (this.cart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]'));
        }
        onSubmitHandler(e) {
          e.preventDefault(),
            this.submitButton.setAttribute("disabled", !0),
            this.submitButton.classList.add("loading");
          let t = document.querySelector(".cart-recommend");
          t && t.classList.contains("open") && t.classList.remove("open");
          let i = document.getElementById("product-form-quick-edit"),
            s = i.getAttribute("data-line"),
            r = fetchConfig("json");
          (r.body = JSON.stringify({ id: s, quantity: 0 })),
            fetch(`${routes?.cart_change_url}`, r)
              .then((e) => e.text())
              .catch((e) => {
                throw e;
              })
              .finally(() => {
                this.addCartAdd();
              });
        }
        addCartAdd() {
          let e = fetchConfig("json");
          (e.headers["X-Requested-With"] = "XMLHttpRequest"),
            delete e.headers["Content-Type"];
          let t = new FormData(this.form);
          this.cart &&
            (t.append(
              "sections",
              this.cart.getSectionsToRender().map((e) => e.id)
            ),
            t.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = t),
            fetch(`${routes?.cart_add_url}`, e)
              .then((e) => e.text())
              .then((e) => {
                this.submitButton.setAttribute("disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  fetch("/cart.json")
                    .then((e) => e.json())
                    .then((e) => {
                      if (void 0 != e.item_count) {
                        document
                          .querySelectorAll(".cart-count")
                          .forEach((t) => {
                            t.classList.contains("cart-count-drawer")
                              ? (t.innerHTML = `(${e.item_count})`)
                              : (t.innerHTML =
                                  e.item_count > 100 ? "~" : e.item_count);
                          }),
                          document.querySelector("header-total-price") &&
                            document
                              .querySelector("header-total-price")
                              .updateTotal(e);
                        let t = document.querySelector(
                          "free-ship-progress-bar"
                        );
                        t && t.init(e.items_subtotal_price);
                      }
                    })
                    .catch((e) => {
                      throw e;
                    });
                let t = JSON.parse(e);
                t.errors ||
                  (this.cart.getSectionsToRender().forEach((e) => {
                    let i = document.getElementById(e.id),
                      s = new DOMParser().parseFromString(
                        t.sections[e.id],
                        "text/html"
                      );
                    i.innerHTML = s.querySelector("#minicart-form").innerHTML;
                  }),
                  document.querySelector(".tingle-modal__close").click());
              })
              .catch((e) => {
                throw e;
              })
              .finally(() => {
                this.submitButton.setAttribute("disabled", !1),
                  this.submitButton
                    .querySelector("span")
                    .classList.remove("hidden");
                let e = document.querySelector(".cart-recommend");
                if (e && !e.classList.contains("hidden-recommend")) {
                  if (e.classList.contains("cart-recommend-custom")) {
                    let t = document.querySelectorAll(".cart-upsell-item"),
                      i = document.querySelectorAll(
                        ".swiper-cart-upsell .swiper-slide"
                      );
                    t.length > 0
                      ? setTimeout(function () {
                          e.classList.add("open");
                        }, 800)
                      : 0 === i.length &&
                        (e.classList.remove("block"),
                        e.classList.add("hidden"));
                  } else
                    setTimeout(function () {
                      e.classList.add("open");
                    }, 800);
                }
              });
        }
      }
    );
class Loadmore extends HTMLElement {
  constructor() {
    super(),
      (this.button = this.querySelector("button")),
      (this.collectionUrl = this.dataset.collectionUrl),
      (this.sectionId = this.dataset.sectionId),
      (this.all = this.dataset.allProducts),
      (this.limit = this.dataset.limit),
      (this.blockId = this.dataset.blockId),
      this.init();
  }
  init() {
    let e = this;
    this.button &&
      this.button.addEventListener("click", function () {
        e.scanData();
      });
  }
  scanData() {
    let e = this,
      t = this.dataset.url;
    t &&
      (this.querySelector("button").classList.add("loading"),
      fetch(this.collectionUrl + t + `&section_id=${this.sectionId}`)
        .then((e) => e.text())
        .then((e) => {
          let t = parser.parseFromString(e, "text/html"),
            i = this.closest(".sec__products-loadmore");
          if (!i) return;
          let s, r, a, o, n, l, c;
          this.blockId
            ? ((r = i.querySelector(
                `.collection-tab-${this.blockId} .product-ajax__append`
              )),
              (s = (a = t.querySelector(
                `.sec__products-loadmore .collection-tab-${this.blockId} .product-ajax__append`
              )).querySelectorAll(".grid-custom-item")))
            : ((r = i.querySelector(".product-ajax__append")),
              (s = (a = t.querySelector(
                ".sec__products-loadmore .product-ajax__append"
              )).querySelectorAll(".grid-custom-item"))),
            r &&
              a &&
              ((n =
                (o = Number(this.dataset.url.replace("?page=", ""))) *
                this.limit),
              (l = this.limit),
              (c = !1),
              n >= this.all && ((c = !0), (l = this.limit - (n - this.all))),
              s.forEach((e, t) => {
                (t += 1), (!c || !(l < t)) && r.appendChild(e);
              }));
        })
        .finally(() => {
          e.updateUrl(Number(this.dataset.url.replace("?page=", ""))),
            this.querySelector("button")?.classList.remove("loading"),
            BlsAnimations.innit(),
            initLazyloadItem();
        })
        .catch((e) => {
          console.error(e);
        }));
  }
  updateUrl(e) {
    if (this.all && this.limit && this.all > 0) {
      let t = ~~(this.all / this.limit),
        i = this.all % this.limit,
        s = t;
      if ((i > 0 && (s = t + 1), e < s)) this.dataset.url = "?page=" + ++e;
      else {
        let r = this.querySelector("button");
        r && r.remove();
      }
    }
  }
  handleCountItemToShow(e) {
    if (
      this.all &&
      this.limit &&
      e &&
      Number(this.all) < Number(this.limit) * e
    ) {
      let t = Number(this.limit) * e - Number(this.all);
      return t;
    }
    return 0;
  }
}
customElements.define("loadmore-function", Loadmore);
class SectionSlideInstagramShop extends SlideSection {
  constructor() {
    super(), this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(e) {
    this.globalSlide.slideTo(e - 1, 500);
  }
}
customElements.define("slide-section-instagram", SectionSlideInstagramShop);
class TabItems extends HTMLElement {
  constructor() {
    super(),
      (this.tabs = this.querySelectorAll(".collection-tab__tab-item")),
      (this.select = this.querySelector(".select-collection-tab")),
      (this.content = this.querySelectorAll(".collection-tab__tab-content")),
      (this.select_li = this.querySelectorAll(".collection_title_input")),
      (this.type = this.dataset.type),
      this.init();
  }
  init() {
    if ("horizontal" === this.type) {
      let e = this;
      this.tabs.forEach((t) => {
        t.addEventListener("click", function () {
          e.onClick(this);
        });
      });
    } else {
      let t = this;
      this.select.addEventListener("click", function (e) {
        if (e.target.classList.contains("select__selected_title")) {
          let t = this.querySelector(".select-custom__content");
          this.classList.toggle("active"), t.classList.toggle("invisible");
        }
      }),
        document.addEventListener("click", function (e) {
          e.target.closest(".select-collection-tab") ||
            (t.select.classList.remove("active"),
            document
              .querySelectorAll(
                ".select-collection-tab .select-custom__content"
              )
              ?.forEach((e) => {
                e.classList.add("invisible");
              }));
        }),
        this.select_li.forEach((e) => {
          e.addEventListener("click", function () {
            t.onClickBySelect(this),
              t.select.classList.remove("active"),
              document
                .querySelectorAll(
                  ".select-collection-tab .select-custom__content"
                )
                ?.forEach((e) => {
                  e.classList.add("invisible");
                });
          });
        });
    }
  }
  onClick(e) {
    let t = e.dataset.blockId;
    this.showContent(t),
      this.tabs.forEach((e) => {
        e.classList.remove("active");
      }),
      e.classList.add("active");
  }
  onClickBySelect(e) {
    (this.querySelector(".select__selected_title").innerHTML =
      e.innerHTML +
      `<svg class="icon-down transition active-rotated" width="10" height="6">
    <use href="#icon-arrow-down"></use>
  </svg>`),
      this.showContent(e.dataset.id);
  }
  showContent(e) {
    this.content.forEach((t) => {
      t.dataset.blockId === e
        ? t.classList.add("active")
        : t.classList.remove("active");
    });
  }
}
customElements.define("tab-items", TabItems);
class ShopableVideo extends PopupBase {
  constructor() {
    super(),
      (this.popupDiv = this.querySelector(".video-item__popup")),
      (this.productPopupDiv = this.querySelector(
        ".video-item__product-mobile"
      )),
      this.init();
  }
  init() {
    (this.popupDiv || !this.classList.contains("instagram-item")) &&
      (window.addEventListener("resize", this.responsive.bind(this)),
      window.addEventListener("load", this.responsive.bind(this)),
      this.addEventListener("click", this.onClick.bind(this)),
      this.connectedCallback()),
      this.productPopupDiv &&
        this.productPopupDiv.addEventListener(
          "click",
          this.onClickMobile.bind(this.productPopupDiv)
        );
  }
  onClick() {
    if (this.popupDiv) {
      let e = this.popupDiv;
      e && (e.classList.remove("hidden"), this.initPopup(e));
    } else if (this.classList.contains("instagram-item")) {
      let t = this.dataset.sectionId,
        i = this.dataset.index,
        s = `${window.location.pathname}?section_id=${t}&ajax=1`;
      var r = this;
      fetch(`${s}`)
        .then((e) => {
          if (!e.ok) throw Error(e.status);
          return e.text();
        })
        .then((e) => {
          let t = new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(`.popup-index-${i}`);
          r.appendChild(t);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          let e = r.querySelector(".popup-content");
          e && (e.classList.remove("hidden"), this.initPopup(e));
        });
    }
  }
  onCloseEvent() {
    let e = document.querySelector(".tingle-modal.shopable-video");
    if (!e) return;
    let t = e.querySelector(".shopable-video__product-information");
    t && t.classList.add("hidden");
  }
  connectedCallback() {
    let e = (e, t) => {
      if (!e[0].isIntersecting) return;
      t.unobserve(this);
      let i = this.querySelectorAll("video");
      i.forEach((e) => {
        let t = e.dataset.src;
        t && ((e.src = t), e.removeAttribute("data-src"));
      });
    };
    new IntersectionObserver(e.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }
  responsive() {
    let e = document.querySelectorAll(".shopable-video__product-information");
    if (0 != e.length) {
      if (window.innerWidth >= 768) {
        let t = this.popupDiv?.querySelector(".video-item__popup--flex");
        if (!t) return;
        e.forEach((e) => {
          e.classList.remove("hidden");
        });
      } else {
        let i = this.popupDiv?.querySelector(".video-item__popup--flex");
        if (!i) return;
        e.forEach((e) => {
          e.classList.add("hidden");
        });
      }
    }
  }
  onClickMobile() {
    let e = this.closest(".video-item__popup");
    if (!e) return;
    let t = e.querySelector(".shopable-video__product-information");
    t && t.classList.toggle("hidden");
  }
}
customElements.define("shopable-video", ShopableVideo);
class InstagramShop extends ShopableVideo {
  constructor() {
    super(),
      (this.popupDiv = this.querySelector(".popup-content")),
      (this.popupDiv || this.classList.contains("instagram-item")) &&
        this.addEventListener("click", this.onClick.bind(this));
  }
}
customElements.define("instagram-shop", InstagramShop);
class InstagramSection extends HTMLElement {
  constructor() {
    super(),
      (this.accessToken = this.dataset.accessToken),
      (this.type = this.dataset.type),
      (this.ratio = this.dataset.ratio),
      this.init();
  }
  async init() {
    if (this.accessToken) {
      let e = await this.fetchDataInstagram(
        `https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=${this.accessToken}`
      );
      if (e) {
        if (e.error)
          return console.error("Instagram error: ", e.error?.message);
        "carousel" === this.type
          ? this.generateCarousel(e.data, this.ratio)
          : this.generateGrid(e.data, this.ratio);
      }
    }
  }
  fetchDataInstagram(e) {
    let t = new Map();
    return new Promise((i, s) => {
      if (t.get(e)) return i(t.get(e));
      fetch(e, { cache: "force-cache" })
        .then((r) => {
          if (r.ok) {
            let a = r.json();
            return i(a), t.set(e, a), a;
          }
          s(r);
        })
        .catch(s);
    });
  }
  generateCarousel(e, t) {
    let i = this.querySelector(".swiper-wrapper");
    if (i) {
      let s = "";
      e.forEach((e) => {
        "VIDEO" === e.media_type
          ? (s += `<a href="${e.permalink}" aria-label="${e.caption}" class="swiper-slide">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${t};">
                                    <video loop="true" muted="true" playsinline="true" autoplay="true" src="${e.media_url}"></video>
                                </div>
                            </a>`)
          : (s += `<a href="${e.permalink}" aria-label="${e.caption}" class="swiper-slide">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${t};">
                                    <img src="${e.media_url}" srcset="${e.media_url}&amp;width=720 720w, ${e.media_url}&amp;width=660 660w, ${e.media_url}&amp;width=550 550w, ${e.media_url}&amp;width=480 480w, ${e.media_url}&amp;width=360 360w" width="1000" height="1000" loading="lazy" sizes="(min-width: 1200px) calc((100vw - 0px * 0) * 1), (min-width: 768px) calc( (100vw - 0px * 0 ) * 1), calc( (100vw - 0 * 0 ) * 1)" alt="${e.caption}">
                                </div>
                            </a>`);
      }),
        (i.innerHTML = s);
    }
  }
  generateGrid(e, t) {
    let i = this.querySelector(".instagram--grid");
    if (i) {
      let s = "";
      e.forEach((e) => {
        "VIDEO" === e.media_type
          ? (s += `<a href="${e.permalink}" aria-label="${e.caption}">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${t};">
                                    <video loop="true" muted="true" playsinline="true" autoplay="true" src="${e.media_url}"></video>
                                </div>
                            </a>`)
          : (s += `<a href="${e.permalink}" aria-label="${e.caption}">
                                <div class="instagram-item__media--ratio" style="--aspect-ratio: ${t};">
                                    <img src="${e.media_url}" srcset="${e.media_url}&amp;width=720 720w, ${e.media_url}&amp;width=660 660w, ${e.media_url}&amp;width=550 550w, ${e.media_url}&amp;width=480 480w, ${e.media_url}&amp;width=360 360w" width="1000" height="1000" loading="lazy" sizes="(min-width: 1200px) calc((100vw - 0px * 0) * 1), (min-width: 768px) calc( (100vw - 0px * 0 ) * 1), calc( (100vw - 0 * 0 ) * 1)" alt="${e.caption}">
                                </div>
                            </a>`);
      }),
        (i.innerHTML = s);
    }
  }
}
customElements.define("instagram-section", InstagramSection);
class GridCustom extends SlideSection {
  constructor() {
    super(),
      (this.enable = this.dataset.enable),
      (this.parentElementt = document.querySelector(
        `#shopify-section-${this.dataset?.sectionId}`
      )),
      (this.loadmore =
        this.parentElementt?.querySelectorAll("loadmore-function")),
      (this.viewAll = this.parentElementt?.querySelector(".view_all")),
      (this.swiperSlideInnerHtml = this.innerHTML),
      this.init();
  }
  init() {
    if ("true" == this.enable) {
      let e = window.innerWidth;
      window.addEventListener("resize", () => {
        let t = window.innerWidth;
        t <= 767 && e > 767 && this.actionOnMobile(),
          t > 767 && e <= 767 && this.actionOutMobile(),
          (e = t);
      }),
        e <= 767 && this.actionOnMobile();
    }
  }
  actionOnMobile() {
    this.viewAll && this.viewAll.classList.add("hidden"),
      this.loadmore &&
        this.loadmore.length > 0 &&
        this.loadmore.forEach((e) => {
          e.classList.add("hidden"), e.classList.remove("block");
        });
    let e = this.swiperSlideInnerHtml.replaceAll(
        "grid-custom-item",
        "swiper-slide"
      ),
      t = `<div class='swiper-wrapper'>${e}</div> <div
    class="swiper-pagination  ${
      this.enable && 1.5 != this.dataset.mobile ? "flex" : "hidden"
    } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    (this.innerHTML = t), this.initSlide();
  }
  actionOutMobile() {
    this.viewAll && this.viewAll.classList.remove("hidden"),
      (this.innerHTML = this.swiperSlideInnerHtml),
      this.loadmore &&
        this.loadmore.length > 0 &&
        this.loadmore.forEach((e) => {
          e.classList.add("block"), e.classList.remove("hidden");
        });
  }
}
customElements.define("grid-custom", GridCustom);
class SlideWithThumbs extends HTMLElement {
  constructor() {
    super(),
      (this.globalSlide = null),
      (this.thumbnailSlide = null),
      this.init();
  }
  init() {
    let e = this.dataset?.nothumb;
    !e &&
      (this.initThumbnail(),
      Shopify.designMode &&
        document.addEventListener("shopify:section:load", () =>
          this.initThumbnail()
        )),
      this.initSlide(),
      this.pauseMedia(),
      this.playMedia();
  }
  initSlide() {
    var e = "true" === this?.dataset.autoplay;
    let t = "true" === this?.dataset.loop,
      i = this?.dataset.mobile ? this?.dataset.mobile : 1;
    var s = this?.dataset.direction ? this?.dataset.direction : "horizontal",
      r = this?.dataset.autoplaySpeed ? 1e3 * this?.dataset.autoplaySpeed : 3e3,
      a = this?.dataset.speed ? this?.dataset.speed : 400;
    let o = this?.dataset.effect ? this?.dataset.effect : "slide";
    var n = this?.dataset.spacing ? this?.dataset.spacing : 30;
    let l = "true" === this?.dataset.itemMobile;
    (n = Number(n)),
      (r = Number(r)),
      (a = Number(a)),
      e && (e = { delay: r }),
      window.innerWidth < 767 && (s = "horizontal");
    let c = this.querySelector(".main-slide__navigation"),
      d = this.querySelector(".swiper-wrapper-preview");
    this.globalSlide = new Swiper(d, {
      slidesPerView: l ? "auto" : i,
      spaceBetween: n >= 15 ? 15 : n,
      autoplay: e,
      direction: s,
      loop: t,
      effect: o,
      speed: a,
      watchSlidesProgress: !0,
      watchSlidesVisibility: !0,
      navigation: {
        nextEl: c?.querySelector(".swiper-button-next"),
        prevEl: c?.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: !0,
        el: this.querySelector(".swiper-pagination"),
        type: "custom",
        renderCustom: function (e, t, i) {
          return t + "/" + i;
        },
      },
      on: {
        init: function () {
          let e = this.slides[this.activeIndex];
          e && e.classList.contains("cloudimage-360")
            ? (this.allowTouchMove = !1)
            : (this.allowTouchMove = !0);
        },
        slideChange: function () {
          let e = this.slides[this.activeIndex];
          e &&
            (e.classList.contains("media-gallery__model") ||
            e.classList.contains("cloudimage-360")
              ? (this.allowTouchMove = !1)
              : (this.allowTouchMove = !0));
        },
      },
      thumbs: { swiper: this.thumbnailSlide ? this.thumbnailSlide : null },
    });
  }
  initThumbnail() {
    let e = this.querySelector(".thumbnail-slide");
    if (!e) return;
    var t = this.dataset.thumbDirection
      ? this.dataset.thumbDirection
      : "horizontal";
    this.dataset.thumbSlidesPerView && this.dataset.thumbSlidesPerView;
    let i = this.dataset.thumbSpaceBetween
        ? this.dataset.thumbSpaceBetween
        : 10,
      s =
        !this.dataset.thumbWatchSlidesVisibility ||
        this.dataset.thumbWatchSlidesVisibility,
      r = !this.dataset.thumbWatchOverflow || this.dataset.thumbWatchOverflow;
    this.thumbnailSlide = new Swiper(e, {
      direction: "horizontal",
      spaceBetween: i,
      slidesPerView: 5,
      watchSlidesVisibility: s,
      watchSlidesProgress: !0,
      watchOverflow: r,
      breakpoints: {
        768: { direction: t, slidesPerView: "vertical" == t ? 10 : 6 },
      },
    });
  }
  pauseMedia() {
    this.globalSlide.on("slideChange", function () {
      window.pauseAllMedia();
    });
  }
  playMedia() {
    let e = "true" === this?.dataset.autoPlayVideo;
    if (e) {
      var t = document.createElement("script");
      (t.src = "https://player.vimeo.com/api/player.js"),
        document.head.appendChild(t),
        this.globalSlide.on("slideChangeTransitionEnd", function () {
          var e = this.slides[this.activeIndex].querySelector(".media-video");
          e &&
            ("VIDEO" === e.tagName
              ? e.play()
              : "IFRAME" === e.tagName &&
                (e.src.includes("vimeo") && new Vimeo.Player(e).play(),
                e.src.includes("youtube") &&
                  e.contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*"
                  )));
        });
    }
  }
  playActiveSlideVideo(e) {}
  functionGoto(e) {
    this.globalSlide.slideTo(e, 500);
  }
  updateSlide() {
    this.globalSlide.update();
  }
  updateThumbSlide() {
    this.thumbnailSlide.update();
  }
  appendSlide(e) {
    this.globalSlide.appendSlide(e);
  }
}
customElements.define("slide-with-thumbs", SlideWithThumbs);
class ProductRecentlyViewed extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  initData() {
    var e = JSON.parse(
      localStorage.getItem("glozin__recently-viewed-products")
    );
    this.getStoredProducts(e);
  }
  getStoredProducts(e) {
    let t = this.dataset?.limit;
    if (t) {
      var i = "",
        s = "";
      if (e && e.length > 0) {
        let r = e.slice(),
          a = r.slice(0, t);
        s = `&q=id:${(i = a.join("%20OR%20id:"))}`;
      }
    }
    fetch(`${this.dataset.url}${s}`)
      .then((e) => e.text())
      .then((e) => {
        let t = document.createElement("div");
        t.innerHTML = e;
        let i = t.querySelector("recently-viewed-products");
        i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
          0 === i.innerHTML.trim().length && this.remove();
      })
      .finally(() => {
        this.querySelector(".swiper-wrapper") && this.initSlide(),
          initLazyloadItem();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  connectedCallback() {
    let e = this,
      t = (t, i) => {
        t[0].isIntersecting && (i.unobserve(this), e.initData());
      };
    new IntersectionObserver(t.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("recently-viewed-products", ProductRecentlyViewed);
class MediaGallery extends HTMLElement {
  constructor() {
    super();
  }
  setActiveMedia(e, t) {
    let i = this.querySelector('[id^="GalleryViewer"]').querySelector(
      `[data-media-id="${e}"]`
    );
    i &&
      (this.querySelector('[id^="GalleryViewer"]')
        .querySelectorAll("[data-media-id]")
        .forEach((e) => {
          e.classList.remove("is-active");
        }),
      i.classList.add("is-active"),
      t && i.parentElement.prepend(i));
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
customElements.define("media-gallery", MediaGallery);
var BlsCustomer = {
  init: function () {
    this.toggleForm(), this.deleteAddresses(), this.addAddresses();
  },
  toggleForm: function () {
    let e = document.querySelector(".add-address"),
      t = document.querySelector(".cancel-add");
    null !== e &&
      null !== t &&
      (e.addEventListener("click", () => {
        "false" === e.getAttribute("aria-expanded")
          ? (e.setAttribute("aria-expanded", "true"),
            e.closest(".bls-customer__address").classList.add("active"))
          : (e.setAttribute("aria-expanded", "false"),
            e.closest(".bls-customer__address").classList.remove("active"));
      }),
      t.addEventListener("click", () => {
        t.closest(".bls-customer__address").classList.contains("active") &&
          (e.closest(".bls-customer__address").classList.remove("active"),
          e.closest(".add-address").setAttribute("aria-expanded", "false"));
      }));
  },
  deleteAddresses: function () {
    let e = document.querySelectorAll(".address-delete");
    e.forEach((e) => {
      e.addEventListener("click", () => {
        let t = e?.dataset.formId,
          i = e?.dataset.confirmMessage;
        confirm(i || "Are you sure you wish to delete this address?") &&
          Shopify.postLink("/account/addresses/" + t, {
            parameters: { _method: "delete" },
          });
      });
    });
  },
  addAddresses: function () {
    Shopify &&
      document.getElementById("AddressCountryNew") &&
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        { hideElement: "AddressProvinceNewContainer" }
      );
    let e = document.querySelectorAll(".edit-country-option");
    e.forEach((e) => {
      let t = e?.dataset.formId;
      new Shopify.CountryProvinceSelector(
        "AddressCountry_" + t,
        "AddressProvince_" + t,
        { hideElement: "AddressProvinceContainer_" + t }
      );
    });
  },
};
BlsCustomer.init();
class ideaProducts extends HTMLElement {
  constructor() {
    super(),
      (this.view_idea_product = this.querySelector(".view_idea_product")),
      (this.content = this.querySelector(".idea-product-list")),
      (this.close = this.querySelector(".close")),
      this.init();
  }
  init() {
    let e = this;
    this.view_idea_product.addEventListener("click", (t) => {
      e.toggleViewIdeaProducts("show");
    }),
      this.close.addEventListener("click", (t) => {
        e.toggleViewIdeaProducts.bind(e)();
      });
  }
  toggleViewIdeaProducts(e = "hidden") {
    "hidden" == e
      ? this.classList.remove("active")
      : this.classList.add("active");
  }
}
customElements.define("idea-product", ideaProducts);
const outfit_idea = document.querySelector(".outfit_idea");
outfit_idea &&
  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".idea-product")) {
      let t = document.querySelectorAll("idea-product");
      t.forEach((e) => {
        e.toggleViewIdeaProducts();
      });
    }
  });
// List of public holidays in Pakistan
const holidays = [
  "2025-03-23",  // 23rd March
  "2025-05-01",  // 1st May
  "2025-06-04",  // pre-Eid 
  "2025-06-05",  // pre-Eid
  "2025-06-06",  // pre-Eid
  "2025-06-07",  // Eid Day 1
  "2025-06-08",  // Eid Day 2
  "2025-06-09",  // Eid Day 3
  "2025-07-04",  // 8 Muharram
  "2025-07-05",  // 9 Muharram
  "2025-07-06",  // 10 Muharram
  "2025-08-14",  // 14th August
  "2025-12-25"  // 25th December
];

// Utility function to check if a date is a holiday
function isHoliday(date) {
  const formattedDate = date.toISOString().split("T")[0];
  return holidays.includes(formattedDate);
}

// Utility function to add days while skipping Sundays and holidays
function addBusinessDays(date, days) {
  while (days > 0) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && !isHoliday(date)) {
      // If not Sunday or holiday, count as a business day
      days--;
    }
  }
  return date;
}

// Function to format dates without the weekday
function formatDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

// Calculate Dispatch and Delivery Dates
function calculateDates(city) {
  const now = new Date();
  const currentHour = now.getHours();

  // Order Placed (Today)
  const orderDate = new Date(now);

  // Dispatch Date Logic
  const dispatchDate = new Date(orderDate);

  // If today is Sunday or a holiday, or it's after 5 PM, set dispatch to the next working day
  if (orderDate.getDay() === 0 || isHoliday(orderDate) || currentHour >= 17) {
    do {
      dispatchDate.setDate(dispatchDate.getDate() + 1);
    } while (dispatchDate.getDay() === 0 || isHoliday(dispatchDate));
  }

  // Delivery Time Based on City
  let deliveryDays;
  if (city === "karachi") deliveryDays = 2;
  else if (city === "hyderabad") deliveryDays = 3;
  else if (city === "sukkur" || city === "larkana") deliveryDays = 4;
  else if (city === "lahore" || city === "islamabad" || city === "rawalpindi" || city === "faisalabad") deliveryDays = 4;
  else if (city === "gujranwala" || city === "multan") deliveryDays = 5;
  else if (city === "peshawar" || city === "quetta") deliveryDays = 6; 
  else if (city === "gilgit" || city === "murree") deliveryDays = 7;  
  else deliveryDays = 5;


  const deliveryDate = addBusinessDays(new Date(dispatchDate), deliveryDays);

  // Update Order Placed, Dispatch, and Delivery Dates
  document.getElementById("order-date").textContent = formatDate(orderDate);
  document.getElementById("dispatch-date").textContent = formatDate(dispatchDate);
  document.getElementById("delivery-date").textContent = formatDate(deliveryDate);

  // Update Modern Delivery Message
  const dayName = deliveryDate.toLocaleString("default", { weekday: "long" });
  const dateString = `${deliveryDate.getDate()} ${deliveryDate.toLocaleString(
    "default",
    { month: "long" }
  )} ${deliveryDate.getFullYear()}`;

  document.getElementById("city-name").textContent =
    city.charAt(0).toUpperCase() + city.slice(1);
  document.getElementById("delivery-day").textContent = dayName;
  document.getElementById("delivery-date-message").textContent = dateString;
}

(function () {
  function setupCitySelector() {
    var citySelector = document.getElementById("city-selector");
    if (citySelector) {
      citySelector.addEventListener("change", function () {
        calculateDates(this.value);
      });
      citySelector.value = "karachi";
      citySelector.dispatchEvent(new Event("change"));
      return true;
    }
    return false;
  }

  // Pehle turant try karein (agar element already page par hai)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupCitySelector);
  } else {
    setupCitySelector();
  }

  // Agar turant nahi mila (kisi AJAX/popup se baad mein aata hai),
  // to sirf 10 second tak, har 500ms mein check karein — poore body ko hamesha watch nahi karega
  var attempts = 0;
  var retryInterval = setInterval(function () {
    attempts++;
    if (setupCitySelector() || attempts >= 20) {
      clearInterval(retryInterval);
    }
  }, 500);
})();